const products = {
    "ampicillin-sodium-solution": {
		"complements": [
			"zyppy-plasmid-miniprep-kit",
			"zymopure-ii-plasmid-midiprep-kit",
			"kanamycin-sulfate-solution"
		]
	},
	"chloramphenicol-solution": {
		"complements": [
			"dna-clean-concentrator-5",
			"kanamycin-sulfate-solution",
			"zymo-spin-ic-columns"
		]
	},
	"kanamycin-sulfate-solution": {
		"complements": [
			"zyppy-plasmid-miniprep-kit",
			"ampicillin-sodium-solution",
			"rattler-plating-beads"
		]
	},
	"tetracycline-hydrochloride-solution-reagent-grade": {
		"complements": [
			"zymoprep-yeast-plasmid-miniprep-ii",
			"zymopure-ii-plasmid-midiprep-kit",
			"zymobroth"
		]
	},
	"l-arabinose-solution": {
		"complements": [
			"ampicillin-sodium-solution",
			"iptg-isopropyl-b-d-thiogalactopyranoside",
			"kanamycin-sulfate-solution"
		]
	},
	"anti-5-methylcytosine-monoclonal-antibody-clone-7d21": {
		"cat_number": "A3002-50",
		"product_handle": "anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"rna-clean-concentrator-5",
			"direct-zol-rna-microprep-kits",
		]
	},
	"anti-5-hydroxymethylcytosine-polyclonal-antibody": {
		"cat_number": "A4001-200",
		"product_handle": "anti-5-hydroxymethylcytosine-polyclonal-antibody",
		"complements": [
			"anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
			"quest-5-hmc-dna-elisa-kit",
			"5-mc-dna-elisa-kit",
		]
	},
	"anti-5-hydroxymethylcytosine-polyclonal-antibody": {
		"cat_number": "A4001-25",
		"product_handle": "anti-5-hydroxymethylcytosine-polyclonal-antibody",
		"complements": [
			"control-d",
			"control-c",
			"control-a",
		]
	},
	"anti-5-hydroxymethylcytosine-polyclonal-antibody": {
		"cat_number": "A4001-50",
		"product_handle": "anti-5-hydroxymethylcytosine-polyclonal-antibody",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		]
	},
	"zymo-spin-iin-columns": {
		"cat_number": "C1019-250",
		"product_handle": "zymo-spin-iin-columns",
		"complements": [
			"collection-tubes",
			"zymo-spin-i-columns",
			"dna-clean-concentrator-5",
		]
	},
	"zymo-spin-iin-columns": {
		"cat_number": "C1019-50",
		"product_handle": "zymo-spin-iin-columns",
		"complements": [
			"collection-tubes",
			"zymo-spin-i-columns",
		]
	},
	"600-ml-reservoir": {
		"cat_number": "C1033-5",
		"product_handle": "600-ml-reservoir",
		"complements": [
			"zymo-spin-vi-p-columns",
			"zymopure-wash-1",
			"zymopure-giga-filter",
		]
	},
	"zymopure-syringe-filters": {
		"cat_number": "C1036-5",
		"product_handle": "zymopure-syringe-filters",
		"complements": [
			"zymopure-syringe-plungers",
			"zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"zymopure-syringe-plungers": {
		"cat_number": "C1037-5",
		"product_handle": "zymopure-syringe-plungers",
		"complements": [
			"zymopure-syringe-filters",
			"zymopure-syringe-filter-x",
			"zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
		]
	},
	"zymopure-giga-filter": {
		"cat_number": "C1038-1",
		"product_handle": "zymopure-giga-filter",
		"complements": [
			"600-ml-reservoir",
			"zymopure-binding-buffer",
			"zymopure-wash-1",
		]
	},
	"zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack": {
		"cat_number": "C1040-5",
		"product_handle": "zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
		"complements": [
			"zymopure-syringe-filters",
			"zymopure-syringe-plungers",
			"zymopure-elution-buffer",
		]
	},
	"zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir": {
		"cat_number": "C1042-5",
		"product_handle": "zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
		"complements": [
			"zymopure-syringe-filters",
			"zymopure-syringe-plungers",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"zymo-spin-vi-p-columns": {
		"cat_number": "C1044-5",
		"product_handle": "zymo-spin-vi-p-columns",
		"complements": [
			"600-ml-reservoir",
			"zymopure-giga-filter",
			"zymopure-wash-1",
		]
	},
	"endozero-spin-columns": {
		"cat_number": "C1051-10",
		"product_handle": "endozero-spin-columns",
		"complements": [
			"zymopure-syringe-plungers",
			"zymopure-p1-red",
			"zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
		]
	},
	"endozero-spin-columns": {
		"cat_number": "C1051-5",
		"product_handle": "endozero-spin-columns",
		"complements": [
			"zymopure-syringe-plungers",
			"rna-wash-buffer",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"zymo-spin-ii-p-columns": {
		"cat_number": "C1055-50",
		"product_handle": "zymo-spin-ii-p-columns",
		"complements": [
			"collection-tubes",
			"zymopure-wash-2",
			"zymo-spin-ic-columns",
		]
	},
	"endozero-ii-spin-columns": {
		"cat_number": "C1060-25",
		"product_handle": "endozero-ii-spin-columns",
		"complements": [
			"zymopure-ii-plasmid-midiprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"air-permeable-sealing-cover": {
		"cat_number": "C2011-2",
		"product_handle": "air-permeable-sealing-cover",
		"complements": [
			"96-well-plate-cover-foil",
			"ez-96-dna-methylation-kit",
			"zymopure-wash-1",
		]
	},
	"air-permeable-sealing-cover": {
		"cat_number": "C2011-4",
		"product_handle": "air-permeable-sealing-cover",
		"complements": [
			"m-elution-buffer",
			"chip-dna-binding-buffer",
			"dnase-rnase-free-water",
		]
	},
	"air-permeable-sealing-cover": {
		"cat_number": "C2011-8",
		"product_handle": "air-permeable-sealing-cover",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"elution-plate",
			"96-well-block",
		]
	},
	"zymoprep-yeast-plasmid-miniprep-i": {
		"complements": [
			"yeastar-genomic-dna-kit",
			"zymolyase",
			"frozen-ez-yeast-transformation-ii-kit"
		]
	},
	"solution-3-neutralizing-buffer-1": {
		"cat_number": "D2001-3-15",
		"product_handle": "solution-3-neutralizing-buffer-1",
		"complements": [
			"dna-elution-buffer",
		]
	},
	"yeastar-genomic-dna-kit": {
		"complements": [
			"zymolyase",
			"frozen-ez-yeast-transformation-ii-kit",
			"yeastar-rna-kit",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"yd-digestion-buffer": {
		"cat_number": "D2002-1",
		"product_handle": "yd-digestion-buffer",
		"complements": [
			"yd-lysis-buffer",
			"zymolyase",
			"yeastar-genomic-dna-kit",
		]
	},
	"yd-lysis-buffer": {
		"cat_number": "D2002-2",
		"product_handle": "yd-lysis-buffer",
		"complements": [
			"yd-digestion-buffer",
			"zymolyase",
			"yeastar-genomic-dna-kit",
		]
	},
	"zymoprep-yeast-plasmid-miniprep-ii": {
		"complements": [
			"frozen-ez-yeast-transformation-ii-kit",
			"zymolyase",
			"yeastar-genomic-dna-kit"
		]
	},
	"solution-1-digestion-buffer": {
		"cat_number": "D2004-1-10",
		"product_handle": "solution-1-digestion-buffer",
		"complements": [
			"solution-2-lysis-buffer",
			"solution-3-neutralizing-buffer",
			"zymolyase",
		]
	},
	"solution-1-digestion-buffer": {
		"cat_number": "D2004-1-45",
		"product_handle": "solution-1-digestion-buffer",
		"complements": [
			"solution-2-lysis-buffer",
			"zymolyase",
			"solution-3-neutralizing-buffer",
		]
	},
	"solution-1-digestion-buffer": {
		"cat_number": "D2004-1-90",
		"product_handle": "solution-1-digestion-buffer",
		"complements": [
			"solution-2-lysis-buffer",
			"solution-3-neutralizing-buffer",
			"zymolyase",
		]
	},
	"solution-2-lysis-buffer": {
		"cat_number": "D2004-2-10",
		"product_handle": "solution-2-lysis-buffer",
		"complements": [
			"solution-3-neutralizing-buffer",
			"solution-1-digestion-buffer",
			"zymolyase",
		]
	},
	"solution-2-lysis-buffer": {
		"cat_number": "D2004-2-45",
		"product_handle": "solution-2-lysis-buffer",
		"complements": [
			"solution-3-neutralizing-buffer",
			"solution-1-digestion-buffer",
			"zymolyase",
		]
	},
	"solution-2-lysis-buffer": {
		"cat_number": "D2004-2-90",
		"product_handle": "solution-2-lysis-buffer",
		"complements": [
			"solution-3-neutralizing-buffer",
			"solution-1-digestion-buffer",
			"zymolyase",
		]
	},
	"solution-3-neutralizing-buffer": {
		"cat_number": "D2004-3-180",
		"product_handle": "solution-3-neutralizing-buffer",
		"complements": [
			"solution-2-lysis-buffer",
			"solution-1-digestion-buffer",
			"zymolyase",
		]
	},
	"solution-3-neutralizing-buffer": {
		"cat_number": "D2004-3-20",
		"product_handle": "solution-3-neutralizing-buffer",
		"complements": [
			"solution-2-lysis-buffer",
			"solution-1-digestion-buffer",
			"zymolyase",
		]
	},
	"solution-3-neutralizing-buffer": {
		"cat_number": "D2004-3-90",
		"product_handle": "solution-3-neutralizing-buffer",
		"complements": [
			"solution-2-lysis-buffer",
			"solution-1-digestion-buffer",
			"zymolyase",
		]
	},
	"zymoprep-96-yeast-plasmid-miniprep": {
		"complements": [
			"zymoprep-yeast-plasmid-miniprep-ii",
			"dna-clean-concentrator-5",
			"frozen-ez-yeast-transformation-ii-kit"
		]
	},
	"pinpoint-slide-dna-isolation-system": {
		"cat_number": "D3001",
		"product_handle": "pinpoint-slide-dna-isolation-system",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"pinpoint-solution": {
		"cat_number": "D3001-1",
		"product_handle": "pinpoint-solution",
		"complements": [
			"pinpoint-extraction-buffer",
			"proteinase-k-w-storage-buffer-set",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"pinpoint-extraction-buffer": {
		"cat_number": "D3001-3",
		"product_handle": "pinpoint-extraction-buffer",
		"complements": [
			"pinpoint-solution",
			"pinpoint-binding-buffer",
			"proteinase-k-w-storage-buffer-set",
		]
	},
	"pinpoint-binding-buffer": {
		"cat_number": "D3001-4",
		"product_handle": "pinpoint-binding-buffer",
		"complements": [
			"pinpoint-wash-buffer-concentrate",
			"pinpoint-extraction-buffer",
			"pinpoint-solution",
		]
	},
	"pinpoint-wash-buffer-concentrate": {
		"cat_number": "D3001-5",
		"product_handle": "pinpoint-wash-buffer-concentrate",
		"complements": [
			"pinpoint-binding-buffer",
			"pinpoint-extraction-buffer",
			"proteinase-k-w-storage-buffer-set",
		]
	},
	"genomic-lysis-buffer": {
		"cat_number": "D3004-1-100",
		"product_handle": "genomic-lysis-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"dna-pre-wash-buffer",
			"dna-elution-buffer",
		]
	},
	"genomic-lysis-buffer": {
		"cat_number": "D3004-1-150",
		"product_handle": "genomic-lysis-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"dna-pre-wash-buffer",
		]
	},
	"genomic-lysis-buffer": {
		"cat_number": "D3004-1-200",
		"product_handle": "genomic-lysis-buffer",
		"complements": [
			"chip-dna-clean-concentrator",
			"mix-and-go-e-coli-transformation-kit",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"genomic-lysis-buffer": {
		"cat_number": "D3004-1-250",
		"product_handle": "genomic-lysis-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"dna-elution-buffer",
			"g-dna-wash-buffer",
		]
	},
	"genomic-lysis-buffer": {
		"cat_number": "D3004-1-50",
		"product_handle": "genomic-lysis-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"dna-elution-buffer",
			"dna-pre-wash-buffer",
		]
	},
	"g-dna-wash-buffer": {
		"cat_number": "D3004-2-100",
		"product_handle": "g-dna-wash-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"genomic-lysis-buffer",
			"dna-elution-buffer",
		]
	},
	"g-dna-wash-buffer": {
		"cat_number": "D3004-2-200",
		"product_handle": "g-dna-wash-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"genomic-lysis-buffer",
		]
	},
	"g-dna-wash-buffer": {
		"cat_number": "D3004-2-250",
		"product_handle": "g-dna-wash-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"dna-elution-buffer",
			"quick-dna-magbinding-buffer",
		]
	},
	"g-dna-wash-buffer": {
		"cat_number": "D3004-2-400",
		"product_handle": "g-dna-wash-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"genomic-lysis-buffer",
			"dna-elution-buffer",
		]
	},
	"g-dna-wash-buffer": {
		"cat_number": "D3004-2-50",
		"product_handle": "g-dna-wash-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"dna-elution-buffer",
			"genomic-lysis-buffer",
		]
	},
	"dna-pre-wash-buffer": {
		"cat_number": "D3004-5-15",
		"product_handle": "dna-pre-wash-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"dna-elution-buffer",
			"bashingbead-buffer",
		]
	},
	"dna-pre-wash-buffer": {
		"cat_number": "D3004-5-250",
		"product_handle": "dna-pre-wash-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"dna-elution-buffer",
		]
	},
	"dna-pre-wash-buffer": {
		"cat_number": "D3004-5-30",
		"product_handle": "dna-pre-wash-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"genomic-binding-buffer",
		]
	},
	"dna-pre-wash-buffer": {
		"cat_number": "D3004-5-50",
		"product_handle": "dna-pre-wash-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"genomic-lysis-buffer",
		]
	},
	"quick-dna-96-kit": {
		"cat_number": "D3010",
		"product_handle": "quick-dna-96-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"quick-dna-miniprep-plus-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-dna-96-kit": {
		"cat_number": "D3011",
		"product_handle": "quick-dna-96-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"quick-dna-96-kit": {
		"cat_number": "D3012",
		"product_handle": "quick-dna-96-kit",
		"complements": [
			"quick-dna-miniprep",
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"quick-dna-viral-kit": {
		"cat_number": "D3015",
		"product_handle": "quick-dna-viral-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zr-viral-dna-buffer": {
		"cat_number": "D3015-1-50",
		"product_handle": "zr-viral-dna-buffer",
		"complements": [
			"dnase-rnase-free-water",
			"dna-wash-buffer-concentrate",
			"m-elution-buffer",
		]
	},
	"quick-dna-viral-kit": {
		"cat_number": "D3016",
		"product_handle": "quick-dna-viral-kit",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
		]
	},
	"zr-viral-dna-buffer": {
		"cat_number": "D3016-1-100",
		"product_handle": "zr-viral-dna-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
			"dna-elution-buffer",
			"dnase-rnase-free-water",
		]
	},
	"quick-dna-viral-96-kit": {
		"cat_number": "D3017",
		"product_handle": "quick-dna-viral-96-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"ez-dna-methylation-kit",
		]
	},
	"quick-dna-viral-96-kit": {
		"cat_number": "D3018",
		"product_handle": "quick-dna-viral-96-kit",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"mix-and-go-e-coli-transformation-kit",
			"chip-dna-clean-concentrator",
		]
	},
	"quick-dna-microprep": {
		"cat_number": "D3020",
		"product_handle": "quick-dna-microprep",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-miniprep",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"quick-dna-microprep": {
		"cat_number": "D3021",
		"product_handle": "quick-dna-microprep",
		"complements": [
			"quick-dna-miniprep",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"quick-dna-miniprep": {
		"cat_number": "D3024",
		"product_handle": "quick-dna-miniprep",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-dna-miniprep": {
		"cat_number": "D3025",
		"product_handle": "quick-dna-miniprep",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-dna-urine-kit": {
		"cat_number": "D3061",
		"product_handle": "quick-dna-urine-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"urine-conditioning-buffer": {
		"cat_number": "D3061-1-140",
		"product_handle": "urine-conditioning-buffer",
		"complements": [
			"dna-rna-shield",
			"dna-wash-buffer-concentrate",
		]
	},
	"urine-conditioning-buffer": {
		"cat_number": "D3061-1-8",
		"product_handle": "urine-conditioning-buffer",
		"complements": [
			"urine-collection-cup",
			"dna-rna-shield",
			"bunny-wipe-fecal-sample-collector",
		]
	},
	"clearing-beads": {
		"cat_number": "D3061-2-1",
		"product_handle": "clearing-beads",
		"complements": [
			"urine-dna-prep-buffer",
			"urine-conditioning-buffer",
			"urine-pellet-digestion-buffer",
		]
	},
	"urine-pellet-digestion-buffer": {
		"cat_number": "D3061-3-20",
		"product_handle": "urine-pellet-digestion-buffer",
		"complements": [
			"urine-dna-prep-buffer",
			"urine-conditioning-buffer",
			"urine-dna-wash-buffer",
		]
	},
	"urine-dna-prep-buffer": {
		"cat_number": "D3061-4-10",
		"product_handle": "urine-dna-prep-buffer",
		"complements": [
			"urine-dna-wash-buffer",
			"urine-pellet-digestion-buffer",
			"urine-conditioning-buffer",
		]
	},
	"urine-dna-wash-buffer": {
		"cat_number": "D3061-5-12",
		"product_handle": "urine-dna-wash-buffer",
		"complements": [
			"urine-dna-prep-buffer",
			"urine-conditioning-buffer",
			"urine-pellet-digestion-buffer",
		]
	},
	"urine-collection-kit": {
		"cat_number": "D3062",
		"product_handle": "urine-collection-kit",
		"complements": [
			"bunny-wipe-fecal-sample-collector",
			"direct-zol-rna-microprep-kits",
			"zyppy-plasmid-miniprep-kit",
		]
	},
	"urine-collection-cup": {
		"cat_number": "D3062-1",
		"product_handle": "urine-collection-cup",
		"complements": [
			"urine-conditioning-buffer",
			"dna-rna-shield-collection-tube-w-swab",
		]
	},
	"quick-dna-ffpe-miniprep": {
		"cat_number": "D3067",
		"product_handle": "quick-dna-ffpe-miniprep",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zymobiomics-dna-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"deparaffinization-solution": {
		"cat_number": "D3067-1-20",
		"product_handle": "deparaffinization-solution",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"2x-digestion-buffer",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"genomic-dna-wash-1": {
		"cat_number": "D3067-2-25",
		"product_handle": "genomic-dna-wash-1",
		"complements": [
			"genomic-dna-wash-2",
			"genomic-lysis-buffer",
			"deparaffinization-solution",
		]
	},
	"genomic-dna-wash-2": {
		"cat_number": "D3067-3-12",
		"product_handle": "genomic-dna-wash-2",
		"complements": [
			"genomic-dna-wash-1",
			"genomic-lysis-buffer",
			"deparaffinization-solution",
		]
	},
	"zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4001",
		"product_handle": "zymoclean-gel-dna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"zyppy-plasmid-miniprep-kit",
		]
	},
	"adb-agarose-dissolving-buffer": {
		"cat_number": "D4001-1-100",
		"product_handle": "adb-agarose-dissolving-buffer",
		"complements": [
			"zymo-spin-i-columns",
			"dna-wash-buffer-concentrate",
		]
	},
	"adb-agarose-dissolving-buffer": {
		"cat_number": "D4001-1-50",
		"product_handle": "adb-agarose-dissolving-buffer",
		"complements": [
			"zymo-spin-i-columns",
			"dna-wash-buffer-concentrate",
			"dna-clean-concentrator-5",
		]
	},
	"zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4001T",
		"product_handle": "zymoclean-gel-dna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
		]
	},
	"zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4002",
		"product_handle": "zymoclean-gel-dna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
		]
	},
	"dna-clean-concentrator-5": {
		"cat_number": "D4003",
		"product_handle": "dna-clean-concentrator-5",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"dna-binding-buffer": {
		"cat_number": "D4003-1-25",
		"product_handle": "dna-binding-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
			"dna-elution-buffer",
		]
	},
	"dna-binding-buffer": {
		"cat_number": "D4003-1-L",
		"product_handle": "dna-binding-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
		]
	},
	"dna-wash-buffer-concentrate": {
		"cat_number": "D4003-2-24",
		"product_handle": "dna-wash-buffer-concentrate",
		"complements": [
			"dna-binding-buffer",
			"zymo-spin-i-columns",
			"adb-agarose-dissolving-buffer",
		]
	},
	"dna-wash-buffer-concentrate": {
		"cat_number": "D4003-2-48",
		"product_handle": "dna-wash-buffer-concentrate",
		"complements": [
			"dna-binding-buffer",
			"adb-agarose-dissolving-buffer",
			"zymo-spin-i-columns",
		]
	},
	"dna-wash-buffer-concentrate": {
		"cat_number": "D4003-2-6",
		"product_handle": "dna-wash-buffer-concentrate",
		"complements": [
			"dna-elution-buffer",
		]
	},
	"dna-clean-concentrator-5": {
		"cat_number": "D4003T",
		"product_handle": "dna-clean-concentrator-5",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"rna-clean-concentrator-5",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"dna-clean-concentrator-5": {
		"cat_number": "D4004",
		"product_handle": "dna-clean-concentrator-5",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"dna-binding-buffer": {
		"cat_number": "D4004-1-L",
		"product_handle": "dna-binding-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
			"adb-agarose-dissolving-buffer",
		]
	},
	"dna-clean-concentrator-25": {
		"cat_number": "D4005",
		"product_handle": "dna-clean-concentrator-25",
		"complements": [
			"dna-clean-concentrator-5",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"dna-clean-concentrator-25": {
		"cat_number": "D4006",
		"product_handle": "dna-clean-concentrator-25",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4007",
		"product_handle": "zymoclean-gel-dna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4008",
		"product_handle": "zymoclean-gel-dna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"genomic-dna-clean-concentrator-10": {
		"cat_number": "D4010",
		"product_handle": "genomic-dna-clean-concentrator-10",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"genomic-dna-clean-concentrator-10": {
		"cat_number": "D4011",
		"product_handle": "genomic-dna-clean-concentrator-10",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"dna-clean-concentrator-5": {
		"cat_number": "D4013",
		"product_handle": "dna-clean-concentrator-5",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"dna-clean-concentrator-5": {
		"cat_number": "D4014",
		"product_handle": "dna-clean-concentrator-5",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"zr-plasmid-miniprep-classic": {
		"cat_number": "D4015",
		"product_handle": "zr-plasmid-miniprep-classic",
		"complements": [
			"dna-clean-concentrator-5",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"zr-plasmid-miniprep-classic": {
		"cat_number": "D4016",
		"product_handle": "zr-plasmid-miniprep-classic",
		"complements": [
			"dna-clean-concentrator-5",
			"zymoclean-gel-dna-recovery-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"zr-96-dna-clean-up-kit": {
		"cat_number": "D4017",
		"product_handle": "zr-96-dna-clean-up-kit",
		"complements": [
			"onestep-pcr-inhibitor-removal-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"zr-96-dna-clean-up-kit": {
		"cat_number": "D4018",
		"product_handle": "zr-96-dna-clean-up-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zyppy-plasmid-miniprep-kit": {
		"cat_number": "D4019",
		"product_handle": "zyppy-plasmid-miniprep-kit",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zyppy-plasmid-miniprep-kit": {
		"cat_number": "D4020",
		"product_handle": "zyppy-plasmid-miniprep-kit",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zr-96-zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4021",
		"product_handle": "zr-96-zymoclean-gel-dna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"zymopure-ii-plasmid-maxiprep-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zr-96-zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4022",
		"product_handle": "zr-96-zymoclean-gel-dna-recovery-kit",
		"complements": [
			"chip-dna-clean-concentrator",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set",
		]
	},
	"zr-96-dna-clean-amp-concentrator-5-deep-well": {
		"cat_number": "D4023",
		"product_handle": "zr-96-dna-clean-amp-concentrator-5-deep-well",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
		]
	},
	"zr-96-dna-clean-amp-concentrator-5-deep-well": {
		"cat_number": "D4024",
		"product_handle": "zr-96-dna-clean-amp-concentrator-5-deep-well",
		"complements": [
			"dna-clean-concentrator-5",
			"ez-96-dna-methylation-kit",
		]
	},
	"buffer-p1-red": {
		"cat_number": "D4027-1-10",
		"product_handle": "buffer-p1-red",
		"complements": [
			"buffer-p2-green",
			"buffer-p3-yellow",
			"dna-wash-buffer-concentrate",
		]
	},
	"buffer-p1-red": {
		"cat_number": "D4027-1-160",
		"product_handle": "buffer-p1-red",
		"complements": [
			"buffer-p2-green",
			"buffer-p3-yellow",
			"plasmid-wash-buffer",
		]
	},
	"buffer-p1-red": {
		"cat_number": "D4027-1-20",
		"product_handle": "buffer-p1-red",
		"complements": [
			"buffer-p2-green",
			"buffer-p3-yellow",
			"endo-wash-buffer",
		]
	},
	"buffer-p1-red": {
		"cat_number": "D4027-1-320",
		"product_handle": "buffer-p1-red",
		"complements": [
			"buffer-p2-green",
			"buffer-p3-yellow",
			"endo-wash-buffer",
		]
	},
	"buffer-p1-red": {
		"cat_number": "D4027-1-500",
		"product_handle": "buffer-p1-red",
		"complements": [
			"buffer-p2-green",
			"buffer-p3-yellow",
			"zymopure-express-plasmid-midiprep-kit",
		]
	},
	"buffer-p1-red": {
		"cat_number": "D4027-1-80",
		"product_handle": "buffer-p1-red",
		"complements": [
			"buffer-p2-green",
			"buffer-p3-yellow",
			"plasmid-wash-buffer",
		]
	},
	"buffer-p2-green": {
		"cat_number": "D4027-2-10",
		"product_handle": "buffer-p2-green",
		"complements": [
			"buffer-p1-red",
			"buffer-p3-yellow",
			"dna-wash-buffer-concentrate",
		]
	},
	"buffer-p2-green": {
		"cat_number": "D4027-2-160",
		"product_handle": "buffer-p2-green",
		"complements": [
			"buffer-p1-red",
			"buffer-p3-yellow",
			"zr-plasmid-miniprep-classic",
		]
	},
	"buffer-p2-green": {
		"cat_number": "D4027-2-20",
		"product_handle": "buffer-p2-green",
		"complements": [
			"buffer-p1-red",
			"buffer-p3-yellow",
			"endo-wash-buffer",
		]
	},
	"buffer-p2-green": {
		"cat_number": "D4027-2-250",
		"product_handle": "buffer-p2-green",
		"complements": [
			"buffer-p1-red",
			"buffer-p3-yellow",
		]
	},
	"buffer-p2-green": {
		"cat_number": "D4027-2-320",
		"product_handle": "buffer-p2-green",
		"complements": [
			"buffer-p3-yellow",
			"buffer-p1-red",
		]
	},
	"buffer-p2-green": {
		"cat_number": "D4027-2-80",
		"product_handle": "buffer-p2-green",
		"complements": [
			"buffer-p1-red",
			"buffer-p3-yellow",
			"plasmid-wash-buffer",
		]
	},
	"buffer-p3-yellow": {
		"cat_number": "D4027-3-12",
		"product_handle": "buffer-p3-yellow",
		"complements": [
			"buffer-p2-green",
			"rna-prep-buffer",
			"m-elution-buffer",
		]
	},
	"buffer-p3-yellow": {
		"cat_number": "D4027-3-220",
		"product_handle": "buffer-p3-yellow",
		"complements": [
			"buffer-p1-red",
			"buffer-p2-green",
		]
	},
	"buffer-p3-yellow": {
		"cat_number": "D4027-3-440",
		"product_handle": "buffer-p3-yellow",
		"complements": [
			"buffer-p2-green",
			"buffer-p1-red",
		]
	},
	"buffer-p3-yellow": {
		"cat_number": "D4027-3-50",
		"product_handle": "buffer-p3-yellow",
		"complements": [
			"buffer-p1-red",
			"buffer-p2-green",
			"endo-wash-buffer",
		]
	},
	"plasmid-wash-buffer": {
		"cat_number": "D4027-4-12",
		"product_handle": "plasmid-wash-buffer",
		"complements": [
			"endo-wash-buffer",
			"m-elution-buffer",
			"buffer-p3-yellow",
		]
	},
	"plasmid-wash-buffer": {
		"cat_number": "D4027-4-24",
		"product_handle": "plasmid-wash-buffer",
		"complements": [
			"endo-wash-buffer",
			"buffer-p2-green",
			"dna-wash-buffer-concentrate",
		]
	},
	"plasmid-wash-buffer": {
		"cat_number": "D4027-4-48",
		"product_handle": "plasmid-wash-buffer",
		"complements": [
			"endo-wash-buffer",
			"buffer-p3-yellow",
			"buffer-p1-red",
		]
	},
	"plasmid-wash-buffer": {
		"cat_number": "D4027-4-6",
		"product_handle": "plasmid-wash-buffer",
		"complements": [
			"endo-wash-buffer",
			"buffer-p2-green",
			"m-wash-buffer",
		]
	},
	"dna-clean-concentrator-100": {
		"cat_number": "D4029",
		"product_handle": "dna-clean-concentrator-100",
		"complements": [
			"dna-clean-concentrator-5",
			"dna-clean-concentrator-25",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"dna-clean-concentrator-100": {
		"cat_number": "D4030",
		"product_handle": "dna-clean-concentrator-100",
		"complements": [
			"dna-clean-concentrator-5",
			"dna-binding-buffer",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"dna-clean-concentrator-500": {
		"cat_number": "D4031",
		"product_handle": "dna-clean-concentrator-500",
		"complements": [
			"dna-clean-concentrator-100",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"ez-dna-methylation-kit",
		]
	},
	"dna-clean-concentrator-500": {
		"cat_number": "D4032",
		"product_handle": "dna-clean-concentrator-500",
		"complements": [
			"dna-clean-concentrator-100",
			"dna-binding-buffer",
			"dna-clean-concentrator-5",
		]
	},
	"dna-clean-concentrator-25": {
		"cat_number": "D4033",
		"product_handle": "dna-clean-concentrator-25",
		"complements": [
			"dna-clean-concentrator-5",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"dna-clean-concentrator-25": {
		"cat_number": "D4034",
		"product_handle": "dna-clean-concentrator-25",
		"complements": [
			"dna-clean-concentrator-5",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"zyppy-plasmid-miniprep-kit": {
		"cat_number": "D4036",
		"product_handle": "zyppy-plasmid-miniprep-kit",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"7x-lysis-buffer-blue": {
		"cat_number": "D4036-1-12",
		"product_handle": "7x-lysis-buffer-blue",
		"complements": [
			"neutralization-buffer-yellow",
			"zyppy-wash-buffer-concentrate",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"7x-lysis-buffer-blue": {
		"cat_number": "D4036-1-30",
		"product_handle": "7x-lysis-buffer-blue",
		"complements": [
			"neutralization-buffer-yellow",
			"dnase-i-set",
			"zyppy-wash-buffer-concentrate",
		]
	},
	"7x-lysis-buffer-blue": {
		"cat_number": "D4036-1-48",
		"product_handle": "7x-lysis-buffer-blue",
		"complements": [
			"neutralization-buffer-yellow",
			"endo-wash-buffer",
			"zyppy-wash-buffer-concentrate",
		]
	},
	"7x-lysis-buffer-blue": {
		"cat_number": "D4036-1-6",
		"product_handle": "7x-lysis-buffer-blue",
		"complements": [
			"neutralization-buffer-yellow",
			"zyppy-wash-buffer-concentrate",
			"endo-wash-buffer",
		]
	},
	"7x-lysis-buffer-blue": {
		"cat_number": "D4036-1-60",
		"product_handle": "7x-lysis-buffer-blue",
		"complements": [
			"neutralization-buffer-yellow",
			"zyppy-wash-buffer-concentrate",
			"endo-wash-buffer",
		]
	},
	"neutralization-buffer-yellow": {
		"cat_number": "D4036-2-100",
		"product_handle": "neutralization-buffer-yellow",
		"complements": [
			"7x-lysis-buffer-blue",
			"adb-agarose-dissolving-buffer",
		]
	},
	"neutralization-buffer-yellow": {
		"cat_number": "D4036-2-160",
		"product_handle": "neutralization-buffer-yellow",
		"complements": [
			"7x-lysis-buffer-blue",
			"zyppy-wash-buffer-concentrate",
			"endo-wash-buffer",
		]
	},
	"neutralization-buffer-yellow": {
		"cat_number": "D4036-2-20",
		"product_handle": "neutralization-buffer-yellow",
		"complements": [
			"7x-lysis-buffer-blue",
			"dna-wash-buffer-concentrate",
			"direct-zol-rna-microprep-kits",
		]
	},
	"neutralization-buffer-yellow": {
		"cat_number": "D4036-2-200",
		"product_handle": "neutralization-buffer-yellow",
		"complements": [
			"7x-lysis-buffer-blue",
			"zyppy-wash-buffer-concentrate",
			"zymo-spin-iin-columns",
		]
	},
	"neutralization-buffer-yellow": {
		"cat_number": "D4036-2-40",
		"product_handle": "neutralization-buffer-yellow",
		"complements": [
			"7x-lysis-buffer-blue",
			"mix-and-go-e-coli-transformation-kit",
			"zyppy-wash-buffer-concentrate",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-120",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"zyppy-wash-buffer-concentrate",
			"7x-lysis-buffer-blue",
			"neutralization-buffer-yellow",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-15",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"zyppy-wash-buffer-concentrate",
			"neutralization-buffer-yellow",
			"7x-lysis-buffer-blue",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-160",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"zyppy-wash-buffer-concentrate",
			"7x-lysis-buffer-blue",
			"neutralization-buffer-yellow",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-240",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"dna-clean-concentrator-5",
			"plasmid-wash-buffer",
			"chip-dna-clean-concentrator",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-30",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"buffer-p3-yellow",
			"dna-elution-buffer",
			"buffer-p2-green",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-6",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"m-binding-buffer",
			"plasmid-wash-buffer",
			"dna-wash-buffer-concentrate",
		]
	},
	"endo-wash-buffer": {
		"cat_number": "D4036-3-60",
		"product_handle": "endo-wash-buffer",
		"complements": [
			"plasmid-wash-buffer",
			"buffer-p3-yellow",
			"dna-elution-buffer",
		]
	},
	"zyppy-wash-buffer-concentrate": {
		"cat_number": "D4036-4-12",
		"product_handle": "zyppy-wash-buffer-concentrate",
		"complements": [
			"endo-wash-buffer",
			"neutralization-buffer-yellow",
			"7x-lysis-buffer-blue",
		]
	},
	"zyppy-wash-buffer-concentrate": {
		"cat_number": "D4036-4-24",
		"product_handle": "zyppy-wash-buffer-concentrate",
		"complements": [
			"endo-wash-buffer",
			"collection-tubes",
			"dna-binding-buffer",
		]
	},
	"zyppy-wash-buffer-concentrate": {
		"cat_number": "D4036-4-48",
		"product_handle": "zyppy-wash-buffer-concentrate",
		"complements": [
			"endo-wash-buffer",
			"neutralization-buffer-yellow",
			"7x-lysis-buffer-blue",
		]
	},
	"zyppy-wash-buffer-concentrate": {
		"cat_number": "D4036-4-6",
		"product_handle": "zyppy-wash-buffer-concentrate",
		"complements": [
			"neutralization-buffer-yellow",
			"endo-wash-buffer",
			"7x-lysis-buffer-blue",
		]
	},
	"zyppy-elution-buffer": {
		"cat_number": "D4036-5-10",
		"product_handle": "zyppy-elution-buffer",
		"complements": [
			"zyppy-wash-buffer-concentrate",
			"zymo-spin-ic-columns",
			"quick-dna-microprep-plus-kit",
		]
	},
	"zyppy-elution-buffer": {
		"cat_number": "D4036-5-100",
		"product_handle": "zyppy-elution-buffer",
		"complements": [
			"zyppy-wash-buffer-concentrate",
			"deep-blue-lysis-buffer",
			"neutralization-buffer-yellow",
		]
	},
	"zyppy-elution-buffer": {
		"cat_number": "D4036-5-20",
		"product_handle": "zyppy-elution-buffer",
		"complements": [
			"zyppy-wash-buffer-concentrate",
			"7x-lysis-buffer-blue",
			"endo-wash-buffer",
		]
	},
	"zyppy-elution-buffer": {
		"cat_number": "D4036-5-30",
		"product_handle": "zyppy-elution-buffer",
		"complements": [
			"deep-blue-lysis-buffer",
			"endo-wash-buffer",
			"neutralization-clearing-buffer",
		]
	},
	"zyppy-elution-buffer": {
		"cat_number": "D4036-5-5",
		"product_handle": "zyppy-elution-buffer",
		"complements": [
			"dna-elution-buffer",
			"endo-wash-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"zyppy-elution-buffer": {
		"cat_number": "D4036-5-60",
		"product_handle": "zyppy-elution-buffer",
		"complements": [
			"endo-wash-buffer",
			"zyppy-wash-buffer-concentrate",
			"magbinding-beads",
		]
	},
	"zyppy-plasmid-miniprep-kit": {
		"cat_number": "D4037",
		"product_handle": "zyppy-plasmid-miniprep-kit",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zyppy-96-plasmid-kit": {
		"cat_number": "D4041",
		"product_handle": "zyppy-96-plasmid-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"deep-blue-lysis-buffer": {
		"cat_number": "D4041-1-30",
		"product_handle": "deep-blue-lysis-buffer",
		"complements": [
			"zyppy-elution-buffer",
			"endo-wash-buffer",
			"neutralization-clearing-buffer",
		]
	},
	"deep-blue-lysis-buffer": {
		"cat_number": "D4041-1-48",
		"product_handle": "deep-blue-lysis-buffer",
		"complements": [
			"neutralization-buffer-yellow",
			"neutralization-clearing-buffer",
			"magbinding-beads",
		]
	},
	"neutralization-clearing-buffer": {
		"cat_number": "D4041-4-100",
		"product_handle": "neutralization-clearing-buffer",
		"complements": [
			"deep-blue-lysis-buffer",
			"zyppy-wash-buffer-concentrate",
			"zr-dna-sequencing-clean-up-kit",
		]
	},
	"neutralization-clearing-buffer": {
		"cat_number": "D4041-4-200",
		"product_handle": "neutralization-clearing-buffer",
		"complements": [
			"deep-blue-lysis-buffer",
			"endo-wash-buffer",
			"zymo-spin-i-96-plate",
		]
	},
	"zyppy-96-plasmid-kit": {
		"cat_number": "D4042",
		"product_handle": "zyppy-96-plasmid-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"direct-zol-rna-miniprep-kits",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"zyppy-96-plasmid-kit": {
		"cat_number": "D4043",
		"product_handle": "zyppy-96-plasmid-kit",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"zymoclean-large-fragment-dna-recovery": {
		"cat_number": "D4045",
		"product_handle": "zymoclean-large-fragment-dna-recovery",
		"complements": [
			"dna-clean-concentrator-5",
			"ez-dna-methylation-gold-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zymoclean-large-fragment-dna-recovery": {
		"cat_number": "D4046",
		"product_handle": "zymoclean-large-fragment-dna-recovery",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zr-bac-dna-miniprep-kit": {
		"cat_number": "D4048",
		"product_handle": "zr-bac-dna-miniprep-kit",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"zr-bac-dna-miniprep-kit": {
		"cat_number": "D4049",
		"product_handle": "zr-bac-dna-miniprep-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"zr-dna-sequencing-clean-up-kit": {
		"cat_number": "D4050",
		"product_handle": "zr-dna-sequencing-clean-up-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"sequencing-binding-buffer": {
		"cat_number": "D4050-1-14",
		"product_handle": "sequencing-binding-buffer",
		"complements": [
			"sequencing-wash-buffer",
			"m-elution-buffer",
			"m-desulphonation-buffer",
		]
	},
	"sequencing-binding-buffer": {
		"cat_number": "D4050-1-500",
		"product_handle": "sequencing-binding-buffer",
		"complements": [
			"sequencing-wash-buffer",
			"zr-dna-sequencing-clean-up-kit",
			"zr-96-dna-sequencing-clean-up-kit",
		]
	},
	"sequencing-binding-buffer": {
		"cat_number": "D4050-1-55",
		"product_handle": "sequencing-binding-buffer",
		"complements": [
			"sequencing-wash-buffer",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zr-dna-sequencing-clean-up-kit",
		]
	},
	"sequencing-wash-buffer": {
		"cat_number": "D4050-2-20",
		"product_handle": "sequencing-wash-buffer",
		"complements": [
			"sequencing-binding-buffer",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"m-elution-buffer",
		]
	},
	"sequencing-wash-buffer": {
		"cat_number": "D4050-2-500",
		"product_handle": "sequencing-wash-buffer",
		"complements": [
			"sequencing-binding-buffer",
			"zymo-spin-ib-columns",
			"zr-dna-sequencing-clean-up-kit",
		]
	},
	"sequencing-wash-buffer": {
		"cat_number": "D4050-2-70",
		"product_handle": "sequencing-wash-buffer",
		"complements": [
			"sequencing-binding-buffer",
			"zr-dna-sequencing-clean-up-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zr-dna-sequencing-clean-up-kit": {
		"cat_number": "D4051",
		"product_handle": "zr-dna-sequencing-clean-up-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zr-96-dna-sequencing-clean-up-kit": {
		"cat_number": "D4052",
		"product_handle": "zr-96-dna-sequencing-clean-up-kit",
		"complements": [
			"quick-rna-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zr-96-dna-sequencing-clean-up-kit": {
		"cat_number": "D4053",
		"product_handle": "zr-96-dna-sequencing-clean-up-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"zr-plasmid-miniprep-classic": {
		"cat_number": "D4054",
		"product_handle": "zr-plasmid-miniprep-classic",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5",
		]
	},
	"oligo-clean-concentrator": {
		"cat_number": "D4060",
		"product_handle": "oligo-clean-concentrator",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"oligo-binding-buffer": {
		"cat_number": "D4060-1-10",
		"product_handle": "oligo-binding-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
			"m-desulphonation-buffer",
			"rna-prep-buffer",
		]
	},
	"oligo-binding-buffer": {
		"cat_number": "D4060-1-40",
		"product_handle": "oligo-binding-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
			"dna-binding-buffer",
		]
	},
	"oligo-clean-concentrator": {
		"cat_number": "D4061",
		"product_handle": "oligo-clean-concentrator",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"oligo-clean-concentrator-zr96": {
		"cat_number": "D4062",
		"product_handle": "oligo-clean-concentrator-zr96",
		"complements": [
			"oligo-clean-concentrator",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"oligo-clean-concentrator-zr96": {
		"cat_number": "D4063",
		"product_handle": "oligo-clean-concentrator-zr96",
		"complements": [
			"rna-clean-concentrator-96",
			"ez-dna-methylation-lightning-kit",
			"oligo-clean-concentrator",
		]
	},
	"genomic-dna-clean-concentrator-25": {
		"cat_number": "D4064",
		"product_handle": "genomic-dna-clean-concentrator-25",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"genomic-dna-clean-concentrator-25": {
		"cat_number": "D4065",
		"product_handle": "genomic-dna-clean-concentrator-25",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"rna-clean-concentrator-5",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"zr-96-genomic-dna-clean-concentrator-5-kit": {
		"cat_number": "D4066",
		"product_handle": "zr-96-genomic-dna-clean-concentrator-5-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"rna-clean-concentrator-5",
			"chip-dna-clean-concentrator",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"zr-96-genomic-dna-clean-concentrator-5-kit": {
		"cat_number": "D4067",
		"product_handle": "zr-96-genomic-dna-clean-concentrator-5-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"onestep-pcr-inhibitor-removal-kit",
			"quick-dna-miniprep-plus-kit",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"quick-dna-miniprep-plus-kit": {
		"cat_number": "D4068",
		"product_handle": "quick-dna-miniprep-plus-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"biofluid-cell-buffer-red": {
		"cat_number": "D4068-1-12",
		"product_handle": "biofluid-cell-buffer-red",
		"complements": [
			"genomic-binding-buffer",
			"dna-elution-buffer",
		]
	},
	"biofluid-cell-buffer-red": {
		"cat_number": "D4068-1-25",
		"product_handle": "biofluid-cell-buffer-red",
		"complements": [
			"genomic-binding-buffer",
			"dna-elution-buffer",
			"g-dna-wash-buffer",
		]
	},
	"biofluid-cell-buffer-red": {
		"cat_number": "D4068-1-45",
		"product_handle": "biofluid-cell-buffer-red",
		"complements": [
			"genomic-binding-buffer",
			"g-dna-wash-buffer",
			"dna-pre-wash-buffer",
		]
	},
	"solid-tissue-buffer-blue": {
		"cat_number": "D4068-2-10",
		"product_handle": "solid-tissue-buffer-blue",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"proteinase-k-w-storage-buffer-set",
			"quick-rna-microprep-kit",
		]
	},
	"solid-tissue-buffer-blue": {
		"cat_number": "D4068-2-22",
		"product_handle": "solid-tissue-buffer-blue",
		"complements": [
			"proteinase-k-w-storage-buffer-set",
			"genomic-binding-buffer",
			"g-dna-wash-buffer",
		]
	},
	"solid-tissue-buffer-blue": {
		"cat_number": "D4068-2-6",
		"product_handle": "solid-tissue-buffer-blue",
		"complements": [
			"proteinase-k-w-storage-buffer-set",
			"genomic-binding-buffer",
		]
	},
	"genomic-binding-buffer": {
		"cat_number": "D4068-3-25",
		"product_handle": "genomic-binding-buffer",
		"complements": [
			"biofluid-cell-buffer-red",
			"solid-tissue-buffer-blue",
			"proteinase-k-w-storage-buffer-set",
		]
	},
	"genomic-binding-buffer": {
		"cat_number": "D4068-3-45",
		"product_handle": "genomic-binding-buffer",
		"complements": [
			"solid-tissue-buffer-blue",
			"quick-dna-miniprep-plus-kit",
			"proteinase-k-w-storage-buffer-set",
		]
	},
	"genomic-binding-buffer": {
		"cat_number": "D4068-3-85",
		"product_handle": "genomic-binding-buffer",
		"complements": [
			"proteinase-k-w-storage-buffer-set",
			"quick-dna-miniprep-plus-kit",
			"solid-tissue-buffer-blue",
		]
	},
	"quick-dna-miniprep-plus-kit": {
		"cat_number": "D4068T",
		"product_handle": "quick-dna-miniprep-plus-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"onestep-pcr-inhibitor-removal-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"quick-dna-miniprep-plus-kit": {
		"cat_number": "D4069",
		"product_handle": "quick-dna-miniprep-plus-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"quick-dna-96-plus-kit": {
		"cat_number": "D4070",
		"product_handle": "quick-dna-96-plus-kit",
		"complements": [
			"quick-dna-miniprep",
			"quick-dna-miniprep-plus-kit",
			"quick-rna-miniprep-plus-kit",
		]
	},
	"quick-dna-96-plus-kit": {
		"cat_number": "D4071",
		"product_handle": "quick-dna-96-plus-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"quick-dna-microprep-plus-kit": {
		"cat_number": "D4074",
		"product_handle": "quick-dna-microprep-plus-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-dna-midiprep-plus-kit": {
		"cat_number": "D4075",
		"product_handle": "quick-dna-midiprep-plus-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"quick-cfdna-serum-plasma-kit": {
		"cat_number": "D4076",
		"product_handle": "quick-cfdna-serum-plasma-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"s-p-5x-digestion-buffer": {
		"cat_number": "D4076-1-32",
		"product_handle": "s-p-5x-digestion-buffer",
		"complements": [
			"s-p-dna-prep-buffer",
			"s-p-dna-wash-buffer-concentrate",
			"s-p-dna-binding-buffer",
		]
	},
	"s-p-dna-binding-buffer": {
		"cat_number": "D4076-2-170",
		"product_handle": "s-p-dna-binding-buffer",
		"complements": [
			"s-p-5x-digestion-buffer",
			"s-p-dna-wash-buffer-concentrate",
			"s-p-dna-prep-buffer",
		]
	},
	"s-p-dna-prep-buffer": {
		"cat_number": "D4076-3-10",
		"product_handle": "s-p-dna-prep-buffer",
		"complements": [
			"zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
			"s-p-dna-wash-buffer-concentrate",
			"quick-cfdna-serum-plasma-kit",
		]
	},
	"s-p-dna-wash-buffer-concentrate": {
		"cat_number": "D4076-4-12",
		"product_handle": "s-p-dna-wash-buffer-concentrate",
		"complements": [
			"s-p-dna-prep-buffer",
			"zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
			"quick-cfdna-serum-plasma-kit",
		]
	},
	"quick-cfdna-serum-plasma-buffer-set": {
		"cat_number": "D4076-A",
		"product_handle": "quick-cfdna-serum-plasma-buffer-set",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"quick-cfdna-serum-plasma-kit",
			"dnase-i-set",
		]
	},
	"quick-dna-magbinding-buffer": {
		"cat_number": "D4077-1-150",
		"product_handle": "quick-dna-magbinding-buffer",
		"complements": [
			"g-dna-wash-buffer",
			"dna-pre-wash-buffer",
		]
	},
	"quick-dna-magbinding-buffer": {
		"cat_number": "D4077-1-250",
		"product_handle": "quick-dna-magbinding-buffer",
		"complements": [
			"dna-pre-wash-buffer",
			"g-dna-wash-buffer",
		]
	},
	"select-a-size-binding-buffer": {
		"cat_number": "D4080-1-15",
		"product_handle": "select-a-size-binding-buffer",
		"complements": [
			"dna-wash-buffer-concentrate",
			"select-a-size-dna-clean-concentrator-kit",
		]
	},
	"quick-dna-magbead-plus-kit": {
		"cat_number": "D4081",
		"product_handle": "quick-dna-magbead-plus-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-rna-shield",
		]
	},
	"solid-tissue-digestion-buffer-ii": {
		"cat_number": "D4081-2-22",
		"product_handle": "solid-tissue-digestion-buffer-ii",
		"complements": [
			"zr-96-dna-clean-amp-concentrator-5-deep-well",
			"rna-clean-concentrator-5",
			"ct-conversion-reagent",
		]
	},
	"biofluid-and-solid-tissue-buffer": {
		"cat_number": "D4081-3-100",
		"product_handle": "biofluid-and-solid-tissue-buffer",
		"complements": [
			"quick-dna-magbinding-buffer",
			"dna-pre-wash-buffer",
			"proteinase-k-w-storage-buffer-set",
		]
	},
	"biofluid-and-solid-tissue-buffer": {
		"cat_number": "D4081-3-25",
		"product_handle": "biofluid-and-solid-tissue-buffer",
		"complements": [
			"m-binding-buffer",
			"m-reaction-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"quick-dna-magbead-plus-kit": {
		"cat_number": "D4082",
		"product_handle": "quick-dna-magbead-plus-kit",
		"complements": [
			"dna-rna-shield",
			"dna-clean-concentrator-5",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"select-a-size-dna-clean-concentrator-magbead-kit": {
		"cat_number": "D4084",
		"product_handle": "select-a-size-dna-clean-concentrator-magbead-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"mix-and-go-e-coli-transformation-kit",
			"dna-rna-shield",
		]
	},
	"select-a-size-dna-clean-concentrator-magbead-kit": {
		"cat_number": "D4085",
		"product_handle": "select-a-size-dna-clean-concentrator-magbead-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"dna-rna-shield",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"zyppy-96-plasmid-magbead-kit": {
		"cat_number": "D4100",
		"product_handle": "zyppy-96-plasmid-magbead-kit",
		"complements": [
			"zyppy-96-plasmid-kit",
			"mix-and-go-e-coli-transformation-kit",
			"dna-clean-concentrator-5",
		]
	},
	"magclearing-beads": {
		"cat_number": "D4100-1-10",
		"product_handle": "magclearing-beads",
		"complements": [
			"direct-zol-rna-miniprep-plus-kits",
			"rna-wash-buffer",
			"zymopure-ii-plasmid-miniprep-kit",
		]
	},
	"magclearing-beads": {
		"cat_number": "D4100-1-20",
		"product_handle": "magclearing-beads",
		"complements": [
			"rna-binding-buffer",
			"m-elution-buffer",
			"magbinding-beads",
		]
	},
	"magclearing-beads": {
		"cat_number": "D4100-1-40",
		"product_handle": "magclearing-beads",
		"complements": [
			"magbinding-beads",
			"m-dilution-buffer-gold",
			"deep-blue-lysis-buffer",
		]
	},
	"magbinding-beads": {
		"cat_number": "D4100-2-12",
		"product_handle": "magbinding-beads",
		"complements": [
			"magbead-dna-rna-wash-2",
			"viral-dna-rna-buffer",
			"magbead-dna-rna-wash-1",
		]
	},
	"magbinding-beads": {
		"cat_number": "D4100-2-16",
		"product_handle": "magbinding-beads",
		"complements": [
			"m-binding-buffer",
			"m-wash-buffer",
			"m-elution-buffer",
		]
	},
	"magbinding-beads": {
		"cat_number": "D4100-2-24",
		"product_handle": "magbinding-beads",
		"complements": [
			"dna-wash-buffer-concentrate",
			"zymolyase",
			"solution-2-lysis-buffer",
		]
	},
	"magbinding-beads": {
		"cat_number": "D4100-2-3",
		"product_handle": "magbinding-beads",
		"complements": [
			"m-binding-buffer-gold",
			"magbead-dna-rna-wash-2",
			"dnase-rnase-free-water",
		]
	},
	"magbinding-beads": {
		"cat_number": "D4100-2-6",
		"product_handle": "magbinding-beads",
		"complements": [
			"m-solubilization-buffer",
			"m-elution-buffer",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"magbinding-beads": {
		"cat_number": "D4100-2-8",
		"product_handle": "magbinding-beads",
		"complements": [
			"m-binding-buffer",
			"m-wash-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"zyppy-96-plasmid-magbead-kit": {
		"cat_number": "D4101",
		"product_handle": "zyppy-96-plasmid-magbead-kit",
		"complements": [
			"zyppy-96-plasmid-kit",
			"zr-96-magstand",
			"direct-zol-rna-microprep-kits",
		]
	},
	"zyppy-96-plasmid-magbead-kit": {
		"cat_number": "D4102",
		"product_handle": "zyppy-96-plasmid-magbead-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zymopure-ii-plasmid-midiprep-kit": {
		"cat_number": "D4200",
		"product_handle": "zymopure-ii-plasmid-midiprep-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zymopure-p1-red": {
		"cat_number": "D4200-1-100",
		"product_handle": "zymopure-p1-red",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-p3-yellow",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p1-red": {
		"cat_number": "D4200-1-13",
		"product_handle": "zymopure-p1-red",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-binding-buffer",
			"zymopure-p3-yellow",
		]
	},
	"zymopure-p1-red": {
		"cat_number": "D4200-1-150",
		"product_handle": "zymopure-p1-red",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-p3-yellow",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p1-red": {
		"cat_number": "D4200-1-210",
		"product_handle": "zymopure-p1-red",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p2-blue",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p1-red": {
		"cat_number": "D4200-1-3",
		"product_handle": "zymopure-p1-red",
		"complements": [
			"rna-wash-buffer",
			"zymobiomics-dna-wash-buffer-2",
			"dnase-rnase-free-water",
		]
	},
	"zymopure-p1-red": {
		"cat_number": "D4200-1-410",
		"product_handle": "zymopure-p1-red",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p2-blue",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p2-blue": {
		"cat_number": "D4200-2-100",
		"product_handle": "zymopure-p2-blue",
		"complements": [
			"zymopure-p1-red",
			"zymopure-p3-yellow",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p2-blue": {
		"cat_number": "D4200-2-13",
		"product_handle": "zymopure-p2-blue",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-binding-buffer",
			"zymopure-p1-red",
		]
	},
	"zymopure-p2-blue": {
		"cat_number": "D4200-2-150",
		"product_handle": "zymopure-p2-blue",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p2-blue": {
		"cat_number": "D4200-2-210",
		"product_handle": "zymopure-p2-blue",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p2-blue": {
		"cat_number": "D4200-2-3",
		"product_handle": "zymopure-p2-blue",
		"complements": [
			"rna-wash-buffer",
			"zymobiomics-dna-wash-buffer-2",
			"dnase-rnase-free-water",
		]
	},
	"zymopure-p2-blue": {
		"cat_number": "D4200-2-410",
		"product_handle": "zymopure-p2-blue",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p3-yellow": {
		"cat_number": "D4200-3-100",
		"product_handle": "zymopure-p3-yellow",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p3-yellow": {
		"cat_number": "D4200-3-13",
		"product_handle": "zymopure-p3-yellow",
		"complements": [
			"zymopure-binding-buffer",
			"zymopure-p2-blue",
			"zymopure-p1-red",
		]
	},
	"zymopure-p3-yellow": {
		"cat_number": "D4200-3-150",
		"product_handle": "zymopure-p3-yellow",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p3-yellow": {
		"cat_number": "D4200-3-210",
		"product_handle": "zymopure-p3-yellow",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-p3-yellow": {
		"cat_number": "D4200-3-3",
		"product_handle": "zymopure-p3-yellow",
		"complements": [
			"rna-wash-buffer",
			"zymobiomics-dna-wash-buffer-2",
			"dnase-rnase-free-water",
		]
	},
	"zymopure-p3-yellow": {
		"cat_number": "D4200-3-410",
		"product_handle": "zymopure-p3-yellow",
		"complements": [
			"zymopure-p2-blue",
			"zymopure-p1-red",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-binding-buffer": {
		"cat_number": "D4200-4-110",
		"product_handle": "zymopure-binding-buffer",
		"complements": [
			"zymopure-p1-red",
			"zymopure-p3-yellow",
			"zymopure-p2-blue",
		]
	},
	"zymopure-binding-buffer": {
		"cat_number": "D4200-4-14",
		"product_handle": "zymopure-binding-buffer",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p1-red",
			"zymopure-p2-blue",
		]
	},
	"zymopure-binding-buffer": {
		"cat_number": "D4200-4-150",
		"product_handle": "zymopure-binding-buffer",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p2-blue",
			"zymopure-p1-red",
		]
	},
	"zymopure-binding-buffer": {
		"cat_number": "D4200-4-210",
		"product_handle": "zymopure-binding-buffer",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p1-red",
			"zymopure-p2-blue",
		]
	},
	"zymopure-binding-buffer": {
		"cat_number": "D4200-4-3",
		"product_handle": "zymopure-binding-buffer",
		"complements": [
			"rna-wash-buffer",
			"zymobiomics-dna-wash-buffer-2",
			"dnase-rnase-free-water",
		]
	},
	"zymopure-binding-buffer": {
		"cat_number": "D4200-4-410",
		"product_handle": "zymopure-binding-buffer",
		"complements": [
			"zymopure-p3-yellow",
			"zymopure-p2-blue",
			"zymopure-p1-red",
		]
	},
	"zymopure-wash-1": {
		"cat_number": "D4200-5-20",
		"product_handle": "zymopure-wash-1",
		"complements": [
			"zymopure-wash-2",
			"zymopure-p3-yellow",
			"m-dilution-buffer-gold",
		]
	},
	"zymopure-wash-1": {
		"cat_number": "D4200-5-320",
		"product_handle": "zymopure-wash-1",
		"complements": [
			"zymopure-wash-2",
			"zymopure-p1-red",
			"zymopure-p3-yellow",
		]
	},
	"zymopure-wash-1": {
		"cat_number": "D4200-5-410",
		"product_handle": "zymopure-wash-1",
		"complements": [
			"zymopure-binding-buffer",
			"zymopure-p3-yellow",
			"zymopure-p1-red",
		]
	},
	"zymopure-wash-1": {
		"cat_number": "D4200-5-55",
		"product_handle": "zymopure-wash-1",
		"complements": [
			"zymopure-wash-2",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-wash-2": {
		"cat_number": "D4200-6-10",
		"product_handle": "zymopure-wash-2",
		"complements": [
			"zymopure-wash-1",
			"dna-clean-concentrator-5",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"zymopure-wash-2": {
		"cat_number": "D4200-6-12",
		"product_handle": "zymopure-wash-2",
		"complements": [
			"m-elution-buffer",
			"zymopure-wash-1",
			"dna-elution-buffer",
		]
	},
	"zymopure-wash-2": {
		"cat_number": "D4200-6-23",
		"product_handle": "zymopure-wash-2",
		"complements": [
			"zymopure-wash-1",
			"zymopure-p3-yellow",
			"zymopure-p2-blue",
		]
	},
	"zymopure-wash-2": {
		"cat_number": "D4200-6-28",
		"product_handle": "zymopure-wash-2",
		"complements": [
			"zymopure-wash-1",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-elution-buffer": {
		"cat_number": "D4200-7-12",
		"product_handle": "zymopure-elution-buffer",
		"complements": [
			"zymopure-wash-2",
			"zymopure-wash-1",
			"dna-elution-buffer",
		]
	},
	"zymopure-elution-buffer": {
		"cat_number": "D4200-7-30",
		"product_handle": "zymopure-elution-buffer",
		"complements": [
			"zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
			"zymopure-wash-1",
			"zymopure-binding-buffer",
		]
	},
	"zymopure-elution-buffer": {
		"cat_number": "D4200-7-6",
		"product_handle": "zymopure-elution-buffer",
		"complements": [
			"m-dilution-buffer-gold",
			"m-elution-buffer",
			"zymopure-wash-2",
		]
	},
	"zymopure-ii-plasmid-midiprep-kit": {
		"cat_number": "D4201",
		"product_handle": "zymopure-ii-plasmid-midiprep-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"zymopure-ii-plasmid-maxiprep-kit": {
		"cat_number": "D4202",
		"product_handle": "zymopure-ii-plasmid-maxiprep-kit",
		"complements": [
			"zymopure-ii-plasmid-midiprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zymopure-ii-plasmid-maxiprep-kit": {
		"cat_number": "D4203",
		"product_handle": "zymopure-ii-plasmid-maxiprep-kit",
		"complements": [
			"zymopure-ii-plasmid-midiprep-kit",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"zymopure-ii-plasmid-gigaprep-kit": {
		"cat_number": "D4204",
		"product_handle": "zymopure-ii-plasmid-gigaprep-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"zymopure-ii-plasmid-midiprep-kit",
		]
	},
	"zymopure-ii-plasmid-miniprep-kit": {
		"cat_number": "D4208T",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit",
		"complements": [
			"zymopure-ii-plasmid-midiprep-kit",
			"mix-and-go-e-coli-transformation-kit",
			"dna-rna-shield",
		]
	},
	"zymopure-ii-plasmid-miniprep-kit": {
		"cat_number": "D4209",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"zymoclean-gel-dna-recovery-kit",
			"zymopure-ii-plasmid-midiprep-kit",
		]
	},
	"zymopure-ii-plasmid-miniprep-kit": {
		"cat_number": "D4210",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"zymopure-ii-plasmid-midiprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zymopure-ii-plasmid-miniprep-kit": {
		"cat_number": "D4211",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit",
		"complements": [
			"zymopure-ii-plasmid-midiprep-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"zymopure-ii-plasmid-miniprep-kit": {
		"cat_number": "D4212",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"zymopure-ii-plasmid-midiprep-kit",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"zymopure-express-plasmid-midiprep-kit": {
		"cat_number": "D4213",
		"product_handle": "zymopure-express-plasmid-midiprep-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"zymopure-ii-plasmid-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"zp-express-lysis-buffer": {
		"cat_number": "D4213-1-210",
		"product_handle": "zp-express-lysis-buffer",
		"complements": [
			"zp-express-neutralization-buffer",
			"zymopure-wash-1",
			"zp-express-binding-buffer",
		]
	},
	"zp-express-neutralization-buffer": {
		"cat_number": "D4213-2-260",
		"product_handle": "zp-express-neutralization-buffer",
		"complements": [
			"zp-express-binding-buffer",
			"zp-express-lysis-buffer",
			"zymopure-wash-1",
		]
	},
	"zp-express-binding-buffer": {
		"cat_number": "D4213-3-260",
		"product_handle": "zp-express-binding-buffer",
		"complements": [
			"zp-express-neutralization-buffer",
			"dna-digestion-buffer",
			"dna-elution-buffer",
		]
	},
	"zymobiomics-dna-miniprep-kit": {
		"cat_number": "D4300",
		"product_handle": "zymobiomics-dna-miniprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-rna-shield",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"zymobiomics-lysis-solution": {
		"cat_number": "D4300-1-150",
		"product_handle": "zymobiomics-lysis-solution",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zymobiomics-magbinding-buffer",
			"zymobiomics-magwash-2",
		]
	},
	"zymobiomics-lysis-solution": {
		"cat_number": "D4300-1-40",
		"product_handle": "zymobiomics-lysis-solution",
		"complements": [
			"zymobiomics-dna-binding-buffer",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zymobiomics-dna-wash-buffer-2",
		]
	},
	"zymobiomics-dna-binding-buffer": {
		"cat_number": "D4300-2-100",
		"product_handle": "zymobiomics-dna-binding-buffer",
		"complements": [
			"zymobiomics-dna-wash-buffer-2",
			"zymobiomics-dna-wash-buffer-1",
			"zymobiomics-lysis-solution",
		]
	},
	"zymobiomics-dna-binding-buffer": {
		"cat_number": "D4300-2-250",
		"product_handle": "zymobiomics-dna-binding-buffer",
		"complements": [
			"zymobiomics-dna-wash-buffer-2",
			"zymobiomics-dna-wash-buffer-1",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zymobiomics-dna-wash-buffer-1": {
		"cat_number": "D4300-3-100",
		"product_handle": "zymobiomics-dna-wash-buffer-1",
		"complements": [
			"zymobiomics-dna-wash-buffer-2",
			"zymobiomics-dna-binding-buffer",
			"zymobiomics-dnase-rnase-free-water",
		]
	},
	"zymobiomics-dna-wash-buffer-1": {
		"cat_number": "D4300-3-50",
		"product_handle": "zymobiomics-dna-wash-buffer-1",
		"complements": [
			"zymobiomics-dna-wash-buffer-2",
			"zymobiomics-dna-binding-buffer",
			"zymobiomics-lysis-solution",
		]
	},
	"zymobiomics-dna-wash-buffer-2": {
		"cat_number": "D4300-4-200",
		"product_handle": "zymobiomics-dna-wash-buffer-2",
		"complements": [
			"zymobiomics-dna-wash-buffer-1",
			"zymobiomics-dna-binding-buffer",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zymobiomics-dna-wash-buffer-2": {
		"cat_number": "D4300-4-60",
		"product_handle": "zymobiomics-dna-wash-buffer-2",
		"complements": [
			"zymobiomics-dna-wash-buffer-1",
			"zymobiomics-dna-binding-buffer",
			"zymobiomics-lysis-solution",
		]
	},
	"zymobiomics-hrc-prep-solution": {
		"cat_number": "D4300-7-30",
		"product_handle": "zymobiomics-hrc-prep-solution",
		"complements": [
			"zymo-spin-iii-hrc-filters",
			"dna-rna-shield",
			"dna-rna-wash-buffer-concentrate",
		]
	},
	"zymobiomics-dna-miniprep-kit": {
		"cat_number": "D4300T",
		"product_handle": "zymobiomics-dna-miniprep-kit",
		"complements": [
			"dna-rna-shield",
			"dnase-i-set",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zymobiomics-dna-microprep-kit": {
		"cat_number": "D4301",
		"product_handle": "zymobiomics-dna-microprep-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"zymobiomics-96-magbead-kit": {
		"cat_number": "D4302",
		"product_handle": "zymobiomics-96-magbead-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"direct-zol-rna-microprep-kits",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"zymobiomics-bashingbead-buffer": {
		"cat_number": "D4302-1-150",
		"product_handle": "zymobiomics-bashingbead-buffer",
		"complements": [
			"zymo-spin-iii-f-filters",
			"onestep-pcr-inhibitor-removal-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zymobiomics-magbinding-buffer": {
		"cat_number": "D4302-2-250",
		"product_handle": "zymobiomics-magbinding-buffer",
		"complements": [
			"zymobiomics-magwash-2",
			"zymobiomics-magwash-1",
			"zymobiomics-magbinding-beads",
		]
	},
	"zymobiomics-magwash-1": {
		"cat_number": "D4302-3-100",
		"product_handle": "zymobiomics-magwash-1",
		"complements": [
			"zymobiomics-magwash-2",
			"zymobiomics-magbinding-buffer",
			"zymobiomics-magbinding-beads",
		]
	},
	"zymobiomics-magwash-2": {
		"cat_number": "D4302-4-200",
		"product_handle": "zymobiomics-magwash-2",
		"complements": [
			"zymobiomics-magwash-1",
			"zymobiomics-magbinding-buffer",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zymobiomics-dnase-rnase-free-water": {
		"cat_number": "D4302-5-1",
		"product_handle": "zymobiomics-dnase-rnase-free-water",
		"complements": [
			"dna-elution-buffer",
			"dna-wash-buffer-concentrate",
			"m-digestion-buffer-2x",
		]
	},
	"zymobiomics-dnase-rnase-free-water": {
		"cat_number": "D4302-5-10",
		"product_handle": "zymobiomics-dnase-rnase-free-water",
		"complements": [
			"dna-wash-buffer-concentrate",
			"m-dilution-buffer-gold",
			"dna-elution-buffer",
		]
	},
	"zymobiomics-dnase-rnase-free-water": {
		"cat_number": "D4302-5-30",
		"product_handle": "zymobiomics-dnase-rnase-free-water",
		"complements": [
			"dna-rna-shield",
			"zymobiomics-hrc-prep-solution",
			"dna-digestion-buffer",
		]
	},
	"zymobiomics-dnase-rnase-free-water": {
		"cat_number": "D4302-5-50",
		"product_handle": "zymobiomics-dnase-rnase-free-water",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zymobiomics-magwash-1",
			"zymobiomics-magwash-2",
		]
	},
	"zymobiomics-magbinding-beads": {
		"cat_number": "D4302-6-12",
		"product_handle": "zymobiomics-magbinding-beads",
		"complements": [
			"zymobiomics-magbinding-buffer",
			"zymobiomics-magwash-1",
			"zymobiomics-magwash-2",
		]
	},
	"zymobiomics-magbinding-beads": {
		"cat_number": "D4302-6-6",
		"product_handle": "zymobiomics-magbinding-beads",
		"complements": [
			"magbead-dna-rna-wash-2",
			"magbead-dna-rna-wash-1",
			"dna-rna-lysis-buffer",
		]
	},
	"zymobiomics-96-dna-kit": {
		"cat_number": "D4303",
		"product_handle": "zymobiomics-96-dna-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"zymobiomics-microbial-community-standard",
			"chip-dna-clean-concentrator",
		]
	},
	"zymobiomics-dna-miniprep-kit": {
		"cat_number": "D4304",
		"product_handle": "zymobiomics-dna-miniprep-kit",
		"complements": [
			"onestep-pcr-inhibitor-removal-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zymobiomics-dna-microprep-kit": {
		"cat_number": "D4305",
		"product_handle": "zymobiomics-dna-microprep-kit",
		"complements": [
			"onestep-pcr-inhibitor-removal-kit",
			"dna-rna-shield-lysis-and-collection-tubes",
			"zymopure-ii-plasmid-midiprep-kit",
		]
	},
	"zymobiomics-96-magbead-kit": {
		"cat_number": "D4306",
		"product_handle": "zymobiomics-96-magbead-kit",
		"complements": [
			"zymobiomics-lysis-solution",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-rna-shield",
		]
	},
	"zymobiomics-96-dna-kit": {
		"cat_number": "D4307",
		"product_handle": "zymobiomics-96-dna-kit",
		"complements": [
			"select-a-size-dna-clean-concentrator-kit",
			"zymolyase",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"zymobiomics-96-magbead-kit": {
		"cat_number": "D4308",
		"product_handle": "zymobiomics-96-magbead-kit",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-dna-miniprep-kit",
			"ez-dna-methylation-gold-kit",
		]
	},
	"zymobiomics-96-dna-kit": {
		"cat_number": "D4309",
		"product_handle": "zymobiomics-96-dna-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"hostzero-microbial-dna-kit": {
		"cat_number": "D4310",
		"product_handle": "hostzero-microbial-dna-kit",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"dna-rna-shield",
		]
	},
	"host-depletion-solution": {
		"cat_number": "D4310-1-20",
		"product_handle": "host-depletion-solution",
		"complements": [
			"microbial-selection-buffer",
			"microbial-selection-enzyme",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"microbial-selection-buffer": {
		"cat_number": "D4310-2-5",
		"product_handle": "microbial-selection-buffer",
		"complements": [
			"microbial-selection-enzyme",
			"host-depletion-solution",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"microbial-selection-enzyme": {
		"cat_number": "D4310-3-50",
		"product_handle": "microbial-selection-enzyme",
		"complements": [
			"microbial-selection-buffer",
			"host-depletion-solution",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"ez-dna-methylation-kit": {
		"cat_number": "D5001",
		"product_handle": "ez-dna-methylation-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"ct-conversion-reagent": {
		"cat_number": "D5001-1",
		"product_handle": "ct-conversion-reagent",
		"complements": [
			"zymo-spin-ic-columns",
			"m-dilution-buffer",
			"ez-dna-methylation-gold-kit",
		]
	},
	"ct-conversion-reagent": {
		"cat_number": "D5001-1-50",
		"product_handle": "ct-conversion-reagent",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
		]
	},
	"m-dilution-buffer": {
		"cat_number": "D5001-2",
		"product_handle": "m-dilution-buffer",
		"complements": [
			"ez-dna-methylation-kit",
			"m-desulphonation-buffer",
			"dna-clean-concentrator-5",
		]
	},
	"m-binding-buffer": {
		"cat_number": "D5001-3",
		"product_handle": "m-binding-buffer",
		"complements": [
			"m-wash-buffer",
			"lightning-conversion-reagent",
			"m-elution-buffer",
		]
	},
	"m-wash-buffer": {
		"cat_number": "D5001-4",
		"product_handle": "m-wash-buffer",
		"complements": [
			"m-elution-buffer",
			"lightning-conversion-reagent",
			"m-desulphonation-buffer",
		]
	},
	"m-desulphonation-buffer": {
		"cat_number": "D5001-5",
		"product_handle": "m-desulphonation-buffer",
		"complements": [
			"m-wash-buffer",
			"m-binding-buffer-gold",
			"m-elution-buffer",
		]
	},
	"m-elution-buffer": {
		"cat_number": "D5001-6",
		"product_handle": "m-elution-buffer",
		"complements": [
			"m-wash-buffer",
			"m-desulphonation-buffer",
			"lightning-conversion-reagent",
		]
	},
	"ez-dna-methylation-kit": {
		"cat_number": "D5002",
		"product_handle": "ez-dna-methylation-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"m-dilution-buffer": {
		"cat_number": "D5002-2",
		"product_handle": "m-dilution-buffer",
		"complements": [
			"m-binding-buffer",
			"m-desulphonation-buffer",
			"m-wash-buffer",
		]
	},
	"m-binding-buffer": {
		"cat_number": "D5002-3",
		"product_handle": "m-binding-buffer",
		"complements": [
			"m-desulphonation-buffer",
			"m-dilution-buffer",
			"m-wash-buffer",
		]
	},
	"m-wash-buffer": {
		"cat_number": "D5002-4",
		"product_handle": "m-wash-buffer",
		"complements": [
			"m-desulphonation-buffer",
			"m-elution-buffer",
			"m-dilution-buffer",
		]
	},
	"m-desulphonation-buffer": {
		"cat_number": "D5002-5",
		"product_handle": "m-desulphonation-buffer",
		"complements": [
			"m-binding-buffer",
			"m-wash-buffer",
			"m-dilution-buffer",
		]
	},
	"m-elution-buffer": {
		"cat_number": "D5002-6",
		"product_handle": "m-elution-buffer",
		"complements": [
			"m-wash-buffer",
			"m-desulphonation-buffer",
			"m-binding-buffer-gold",
		]
	},
	"ez-96-dna-methylation-kit": {
		"cat_number": "D5003",
		"product_handle": "ez-96-dna-methylation-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-rna-miniprep-kit",
			"ez-dna-methylation-kit",
		]
	},
	"ct-conversion-reagent-96-conversions": {
		"cat_number": "D5003-1",
		"product_handle": "ct-conversion-reagent-96-conversions",
		"complements": [
			"m-reaction-buffer",
			"m-solubilization-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"ez-96-dna-methylation-kit": {
		"cat_number": "D5004",
		"product_handle": "ez-96-dna-methylation-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"ez-dna-methylation-kit",
		]
	},
	"ez-dna-methylation-gold-kit": {
		"cat_number": "D5005",
		"product_handle": "ez-dna-methylation-gold-kit",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"m-dilution-buffer-gold": {
		"cat_number": "D5005-2",
		"product_handle": "m-dilution-buffer-gold",
		"complements": [
			"m-desulphonation-buffer",
			"m-dissolving-buffer",
			"m-binding-buffer-gold",
		]
	},
	"m-binding-buffer-gold": {
		"cat_number": "D5005-3",
		"product_handle": "m-binding-buffer-gold",
		"complements": [
			"m-wash-buffer",
			"lightning-conversion-reagent",
			"m-desulphonation-buffer",
		]
	},
	"m-dissolving-buffer": {
		"cat_number": "D5005-6",
		"product_handle": "m-dissolving-buffer",
		"complements": [
			"m-dilution-buffer-gold",
			"m-desulphonation-buffer",
			"m-binding-buffer-gold",
		]
	},
	"ez-dna-methylation-gold-kit": {
		"cat_number": "D5006",
		"product_handle": "ez-dna-methylation-gold-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"m-dilution-buffer-gold": {
		"cat_number": "D5006-2",
		"product_handle": "m-dilution-buffer-gold",
		"complements": [
			"m-reaction-buffer",
			"m-solubilization-buffer",
			"m-desulphonation-buffer",
		]
	},
	"m-binding-buffer-gold": {
		"cat_number": "D5006-3",
		"product_handle": "m-binding-buffer-gold",
		"complements": [
			"m-wash-buffer",
			"m-dilution-buffer-gold",
			"m-desulphonation-buffer",
		]
	},
	"m-dissolving-buffer": {
		"cat_number": "D5006-6",
		"product_handle": "m-dissolving-buffer",
		"complements": [
			"m-dilution-buffer-gold",
			"m-binding-buffer-gold",
			"m-desulphonation-buffer",
		]
	},
	"ez-96-dna-methylation-gold-kit": {
		"cat_number": "D5007",
		"product_handle": "ez-96-dna-methylation-gold-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"m-wash-buffer": {
		"cat_number": "D5007-4",
		"product_handle": "m-wash-buffer",
		"complements": [
			"m-desulphonation-buffer",
			"m-elution-buffer",
			"m-binding-buffer-gold",
		]
	},
	"m-elution-buffer": {
		"cat_number": "D5007-6",
		"product_handle": "m-elution-buffer",
		"complements": [
			"m-dilution-buffer-gold",
			"m-reaction-buffer",
			"m-wash-buffer",
		]
	},
	"ez-96-dna-methylation-gold-kit": {
		"cat_number": "D5008",
		"product_handle": "ez-96-dna-methylation-gold-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"chip-dna-clean-concentrator",
		]
	},
	"universal-methylated-dna-standard": {
		"cat_number": "D5011",
		"product_handle": "universal-methylated-dna-standard",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"bisulfite-converted-universal-methylated-human-dna-standard",
		]
	},
	"universal-methylated-dna-standard": {
		"cat_number": "D5012",
		"product_handle": "universal-methylated-dna-standard",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"mix-and-go-competent-cells-tg1",
		]
	},
	"human-methylated-non-methylated-wga-dna-set-dna-w-primers": {
		"cat_number": "D5013",
		"product_handle": "human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"universal-methylated-dna-standard",
		]
	},
	"human-methylated-non-methylated-wga-dna-set-dna-w-primers": {
		"cat_number": "D5013-1",
		"product_handle": "human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"human-methylated-non-methylated-wga-dna-set-dna-w-primers": {
		"cat_number": "D5013-2",
		"product_handle": "human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"human-methylated-non-methylated-dna-set-dna-w-primers": {
		"cat_number": "D5014",
		"product_handle": "human-methylated-non-methylated-dna-set-dna-w-primers",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"ez-dna-methylation-lightning-kit",
		]
	},
	"human-methylated-non-methylated-dna-set-dna-w-primers": {
		"cat_number": "D5014-1",
		"product_handle": "human-methylated-non-methylated-dna-set-dna-w-primers",
		"complements": [
			"universal-methylated-dna-standard",
		]
	},
	"human-methylated-non-methylated-dna-set-dna-w-primers": {
		"cat_number": "D5014-2",
		"product_handle": "human-methylated-non-methylated-dna-set-dna-w-primers",
		"complements": [
			"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		]
	},
	"bisulfite-converted-universal-methylated-human-dna-standard": {
		"cat_number": "D5015",
		"product_handle": "bisulfite-converted-universal-methylated-human-dna-standard",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"universal-methylated-dna-standard",
			"ez-dna-methylation-gold-kit",
		]
	},
	"e-coli-non-methylated-genomic-dna": {
		"cat_number": "D5016",
		"product_handle": "e-coli-non-methylated-genomic-dna",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"methylated-non-methylated-puc19-dna-set": {
		"cat_number": "D5017",
		"product_handle": "methylated-non-methylated-puc19-dna-set",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"zymobiomics-microbial-community-dna-standard",
		]
	},
	"human-matched-dna-set": {
		"cat_number": "D5018",
		"product_handle": "human-matched-dna-set",
		"complements": [
			"universal-methylated-dna-standard",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"human-matched-dna-set": {
		"cat_number": "D5018-1",
		"product_handle": "human-matched-dna-set",
		"complements": [
			"dna-rna-shield",
			"dna-degradase-plus",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"human-matched-dna-set": {
		"cat_number": "D5018-2",
		"product_handle": "human-matched-dna-set",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dnase-i-set",
			"dna-rna-wash-buffer-concentrate",
		]
	},
	"mouse-5hmc-5mc-dna-set": {
		"cat_number": "D5019",
		"product_handle": "mouse-5hmc-5mc-dna-set",
		"complements": [
			"zymobiomics-microbial-community-dna-standard",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"universal-methylated-dna-standard",
		]
	},
	"mouse-5hmc-5mc-dna-set": {
		"cat_number": "D5019-1",
		"product_handle": "mouse-5hmc-5mc-dna-set",
		"complements": [
			"methylated-non-methylated-puc19-dna-set",
			"zymomag-protein-a",
			"5-fluoroorotic-acid",
		]
	},
	"mouse-5hmc-5mc-dna-set": {
		"cat_number": "D5019-2",
		"product_handle": "mouse-5hmc-5mc-dna-set",
		"complements": [
		]
	},
	"mouse-5hmc-5mc-dna-set": {
		"cat_number": "D5019-3",
		"product_handle": "mouse-5hmc-5mc-dna-set",
		"complements": [
			"mix-and-go-competent-cells-dh5-alpha",
			"dna-rna-shield",
			"zymobroth",
		]
	},
	"mouse-5hmc-5mc-dna-set": {
		"cat_number": "D5019-4",
		"product_handle": "mouse-5hmc-5mc-dna-set",
		"complements": [
			"quest-5-hmc-dna-elisa-kit",
			"zymomag-protein-a",
			"quick-dna-plant-seed-miniprep-kit",
		]
	},
	"ez-dna-methylation-direct-kit": {
		"cat_number": "D5020",
		"product_handle": "ez-dna-methylation-direct-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"m-solubilization-buffer": {
		"cat_number": "D5020-7",
		"product_handle": "m-solubilization-buffer",
		"complements": [
			"m-reaction-buffer",
			"m-dilution-buffer-gold",
			"m-desulphonation-buffer",
		]
	},
	"m-reaction-buffer": {
		"cat_number": "D5020-8",
		"product_handle": "m-reaction-buffer",
		"complements": [
			"m-solubilization-buffer",
			"m-dilution-buffer-gold",
			"m-desulphonation-buffer",
		]
	},
	"m-digestion-buffer-2x": {
		"cat_number": "D5020-9",
		"product_handle": "m-digestion-buffer-2x",
		"complements": [
			"m-dilution-buffer-gold",
			"m-binding-buffer-gold",
			"m-wash-buffer",
		]
	},
	"ez-dna-methylation-direct-kit": {
		"cat_number": "D5021",
		"product_handle": "ez-dna-methylation-direct-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
		]
	},
	"m-solubilization-buffer": {
		"cat_number": "D5021-7",
		"product_handle": "m-solubilization-buffer",
		"complements": [
			"m-reaction-buffer",
			"m-dilution-buffer-gold",
			"m-desulphonation-buffer",
		]
	},
	"m-reaction-buffer": {
		"cat_number": "D5021-8",
		"product_handle": "m-reaction-buffer",
		"complements": [
			"m-solubilization-buffer",
			"m-dilution-buffer-gold",
			"m-desulphonation-buffer",
		]
	},
	"m-digestion-buffer-2x": {
		"cat_number": "D5021-9",
		"product_handle": "m-digestion-buffer-2x",
		"complements": [
			"m-reaction-buffer",
			"m-solubilization-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"ez-96-dna-methylation-direct-kit": {
		"cat_number": "D5022",
		"product_handle": "ez-96-dna-methylation-direct-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-direct-kit",
		]
	},
	"ez-96-dna-methylation-direct-kit": {
		"cat_number": "D5023",
		"product_handle": "ez-96-dna-methylation-direct-kit",
		"complements": [
			"ez-96-dna-methylation-kit",
			"zymo-spin-ic-columns",
			"m-solubilization-buffer",
		]
	},
	"ez-dna-methylation-startup-kit": {
		"cat_number": "D5024",
		"product_handle": "ez-dna-methylation-startup-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"zymotaq-dna-polymerase",
			"rna-clean-concentrator-5",
		]
	},
	"ez-dna-methylation-lightning-kit": {
		"cat_number": "D5030",
		"product_handle": "ez-dna-methylation-lightning-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"ez-dna-methylation-gold-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"lightning-conversion-reagent": {
		"cat_number": "D5030-1",
		"product_handle": "lightning-conversion-reagent",
		"complements": [
			"m-wash-buffer",
			"m-binding-buffer-gold",
			"l-desulphonation-buffer",
		]
	},
	"l-desulphonation-buffer": {
		"cat_number": "D5030-5",
		"product_handle": "l-desulphonation-buffer",
		"complements": [
			"lightning-conversion-reagent",
			"m-wash-buffer",
			"m-binding-buffer-gold",
		]
	},
	"ez-dna-methylation-lightning-kit": {
		"cat_number": "D5030T",
		"product_handle": "ez-dna-methylation-lightning-kit",
		"complements": [
			"dnase-i-set",
			"direct-zol-rna-miniprep-kits",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"ez-dna-methylation-lightning-kit": {
		"cat_number": "D5031",
		"product_handle": "ez-dna-methylation-lightning-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"l-desulphonation-buffer": {
		"cat_number": "D5031-5",
		"product_handle": "l-desulphonation-buffer",
		"complements": [
			"m-binding-buffer-gold",
			"lightning-conversion-reagent",
			"m-wash-buffer",
		]
	},
	"ez-96-dna-methylation-lightning-kit": {
		"cat_number": "D5032",
		"product_handle": "ez-96-dna-methylation-lightning-kit",
		"complements": [
			"direct-zol-rna-microprep-kits",
			"dna-clean-concentrator-5",
			"chip-dna-clean-concentrator",
		]
	},
	"lightning-conversion-reagent": {
		"cat_number": "D5032-1",
		"product_handle": "lightning-conversion-reagent",
		"complements": [
			"m-binding-buffer",
			"l-desulphonation-buffer",
			"m-wash-buffer",
		]
	},
	"ez-96-dna-methylation-lightning-kit": {
		"cat_number": "D5033",
		"product_handle": "ez-96-dna-methylation-lightning-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"mix-and-go-e-coli-transformation-kit",
			"dna-clean-concentrator-5",
		]
	},
	"ez-96-dna-methylation-magprep": {
		"cat_number": "D5040",
		"product_handle": "ez-96-dna-methylation-magprep",
		"complements": [
			"dna-clean-concentrator-5",
			"onestep-pcr-inhibitor-removal-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"m-binding-buffer": {
		"cat_number": "D5040-3",
		"product_handle": "m-binding-buffer",
		"complements": [
			"m-wash-buffer",
			"m-desulphonation-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"m-wash-buffer": {
		"cat_number": "D5040-4",
		"product_handle": "m-wash-buffer",
		"complements": [
			"m-binding-buffer",
			"m-desulphonation-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"m-desulphonation-buffer": {
		"cat_number": "D5040-5",
		"product_handle": "m-desulphonation-buffer",
		"complements": [
			"m-binding-buffer",
			"m-wash-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"ez-96-dna-methylation-magprep": {
		"cat_number": "D5041",
		"product_handle": "ez-96-dna-methylation-magprep",
		"complements": [
			"dna-clean-concentrator-5",
			"quick-rna-viral-kit",
			"rna-clean-concentrator-5",
		]
	},
	"m-elution-buffer": {
		"cat_number": "D5041-6",
		"product_handle": "m-elution-buffer",
		"complements": [
			"m-binding-buffer",
			"m-wash-buffer",
			"m-desulphonation-buffer",
		]
	},
	"ez-96-dna-methylation-gold-magprep": {
		"cat_number": "D5042",
		"product_handle": "ez-96-dna-methylation-gold-magprep",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"rna-clean-concentrator-25",
			"dna-clean-concentrator-5",
		]
	},
	"ez-96-dna-methylation-gold-magprep": {
		"cat_number": "D5043",
		"product_handle": "ez-96-dna-methylation-gold-magprep",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"direct-zol-rna-microprep-kits",
			"frozen-ez-yeast-transformation-ii-kit",
		]
	},
	"ez-96-dna-methylation-direct-magprep": {
		"cat_number": "D5044",
		"product_handle": "ez-96-dna-methylation-direct-magprep",
		"complements": [
			"direct-zol-rna-microprep-kits",
			"direct-zol-rna-miniprep-plus-kits",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"ez-96-dna-methylation-direct-magprep": {
		"cat_number": "D5045",
		"product_handle": "ez-96-dna-methylation-direct-magprep",
		"complements": [
			"onestep-pcr-inhibitor-removal-kit",
			"quick-dna-miniprep-plus-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"ez-96-dna-methylation-lightning-magprep": {
		"cat_number": "D5046",
		"product_handle": "ez-96-dna-methylation-lightning-magprep",
		"complements": [
			"dna-clean-concentrator-5",
			"ez-dna-methylation-lightning-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"l-desulphonation-buffer": {
		"cat_number": "D5046-5",
		"product_handle": "l-desulphonation-buffer",
		"complements": [
			"m-binding-buffer",
			"m-wash-buffer",
			"lightning-conversion-reagent",
		]
	},
	"ez-96-dna-methylation-lightning-magprep": {
		"cat_number": "D5047",
		"product_handle": "ez-96-dna-methylation-lightning-magprep",
		"complements": [
			"onestep-pcr-inhibitor-removal-kit",
			"rna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"methylated-dna-ip-kit": {
		"cat_number": "D5101",
		"product_handle": "methylated-dna-ip-kit",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"methylated-non-methylated-control-dna-primer-set": {
		"cat_number": "D5101-2",
		"product_handle": "methylated-non-methylated-control-dna-primer-set",
		"complements": [
			"mix-and-go-competent-cells-tg1",
			"x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside",
			"zymotaq-premix",
		]
	},
	"mip-buffer": {
		"cat_number": "D5101-3-20",
		"product_handle": "mip-buffer",
		"complements": [
			"dna-elution-buffer",
			"dna-denaturing-buffer",
			"zymomag-protein-a",
		]
	},
	"dna-denaturing-buffer": {
		"cat_number": "D5101-4-1",
		"product_handle": "dna-denaturing-buffer",
		"complements": [
			"dna-elution-buffer",
			"mip-buffer",
			"zymomag-protein-a",
		]
	},
	"chip-dna-clean-concentrator": {
		"cat_number": "D5201",
		"product_handle": "chip-dna-clean-concentrator",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"chip-dna-binding-buffer": {
		"cat_number": "D5201-1-100",
		"product_handle": "chip-dna-binding-buffer",
		"complements": [
			"chip-dna-clean-concentrator",
			"dna-wash-buffer-concentrate",
			"zymo-spin-ic-columns",
		]
	},
	"chip-dna-binding-buffer": {
		"cat_number": "D5201-1-50",
		"product_handle": "chip-dna-binding-buffer",
		"complements": [
			"chip-dna-clean-concentrator",
			"dna-wash-buffer-concentrate",
			"dna-clean-concentrator-5",
		]
	},
	"chip-dna-clean-concentrator": {
		"cat_number": "D5205",
		"product_handle": "chip-dna-clean-concentrator",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zr-96-chip-dna-clean-concentrator": {
		"cat_number": "D5206",
		"product_handle": "zr-96-chip-dna-clean-concentrator",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"rna-clean-concentrator-5",
			"ez-dna-methylation-kit",
		]
	},
	"zr-96-chip-dna-clean-concentrator": {
		"cat_number": "D5207",
		"product_handle": "zr-96-chip-dna-clean-concentrator",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"zymo-spin-ic-columns",
			"direct-zol-rna-microprep-kits",
		]
	},
	"zymo-spin-chip-kit": {
		"cat_number": "D5209",
		"product_handle": "zymo-spin-chip-kit",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"zymo-spin-chip-kit": {
		"cat_number": "D5210",
		"product_handle": "zymo-spin-chip-kit",
		"complements": [
			"chip-dna-clean-concentrator",
			"zymo-spin-ic-columns",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"chromatin-shearing-buffer": {
		"cat_number": "D5210-1-30",
		"product_handle": "chromatin-shearing-buffer",
		"complements": [
			"chromatin-dilution-buffer",
			"chromatin-wash-buffer-iii",
			"nuclei-prep-buffer",
		]
	},
	"chromatin-dilution-buffer": {
		"cat_number": "D5210-2-30",
		"product_handle": "chromatin-dilution-buffer",
		"complements": [
			"chromatin-wash-buffer-i",
			"chromatin-wash-buffer-ii",
			"chromatin-wash-buffer-iii",
		]
	},
	"chromatin-wash-buffer-i": {
		"cat_number": "D5210-3-30",
		"product_handle": "chromatin-wash-buffer-i",
		"complements": [
			"chromatin-wash-buffer-ii",
			"chromatin-wash-buffer-iii",
			"chromatin-dilution-buffer",
		]
	},
	"chromatin-wash-buffer-ii": {
		"cat_number": "D5210-4-30",
		"product_handle": "chromatin-wash-buffer-ii",
		"complements": [
			"chromatin-wash-buffer-iii",
			"chromatin-wash-buffer-i",
			"chromatin-dilution-buffer",
		]
	},
	"chromatin-wash-buffer-iii": {
		"cat_number": "D5210-5-30",
		"product_handle": "chromatin-wash-buffer-iii",
		"complements": [
			"chromatin-wash-buffer-ii",
			"chromatin-wash-buffer-i",
			"chromatin-dilution-buffer",
		]
	},
	"5x-chromatin-elution-buffer": {
		"cat_number": "D5210-6-10",
		"product_handle": "5x-chromatin-elution-buffer",
		"complements": [
			"chromatin-wash-buffer-i",
			"chromatin-wash-buffer-iii",
			"chromatin-wash-buffer-ii",
		]
	},
	"5m-nacl": {
		"cat_number": "D5210-7-1",
		"product_handle": "5m-nacl",
		"complements": [
			"quick-rna-microprep-kit",
			"zymo-spin-ic-columns",
			"dna-wash-buffer-concentrate",
		]
	},
	"ez-nucleosomal-dna-prep-kit": {
		"cat_number": "D5220",
		"product_handle": "ez-nucleosomal-dna-prep-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"atlantis-ds-dnase",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"micrococcal-nuclease": {
		"cat_number": "D5220-1",
		"product_handle": "micrococcal-nuclease",
		"complements": [
			"atlantis-ds-dnase",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		]
	},
	"nuclei-prep-buffer": {
		"cat_number": "D5220-2",
		"product_handle": "nuclei-prep-buffer",
		"complements": [
			"atlantis-digestion-buffer",
			"5x-mn-stop-buffer",
			"mn-digestion-buffer",
		]
	},
	"nuclei-prep-buffer": {
		"cat_number": "D5220-2-30",
		"product_handle": "nuclei-prep-buffer",
		"complements": [
			"chromatin-shearing-buffer",
			"chromatin-dilution-buffer",
			"dna-wash-buffer-concentrate",
		]
	},
	"mn-digestion-buffer": {
		"cat_number": "D5220-3",
		"product_handle": "mn-digestion-buffer",
		"complements": [
			"5x-mn-stop-buffer",
			"nuclei-prep-buffer",
			"atlantis-digestion-buffer",
		]
	},
	"5x-mn-stop-buffer": {
		"cat_number": "D5220-4",
		"product_handle": "5x-mn-stop-buffer",
		"complements": [
			"atlantis-digestion-buffer",
			"nuclei-prep-buffer",
			"mn-digestion-buffer",
		]
	},
	"onestep-plus-qmethyl-pcr-kit": {
		"cat_number": "D5312",
		"product_handle": "onestep-plus-qmethyl-pcr-kit",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"ez-dna-methylation-gold-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"2x-reaction-premix": {
		"cat_number": "D5310-1",
		"product_handle": "2x-reaction-premix",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"onestep-plus-qmethyl-pcr-kit",
		]
	},
	"2x-reaction-premix": {
		"cat_number": "D5310-2",
		"product_handle": "2x-reaction-premix",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"direct-zol-rna-miniprep-kits",
			"quick-dna-miniprep",
		]
	},
	"5-mc-dna-elisa-kit": {
		"cat_number": "D5325",
		"product_handle": "5-mc-dna-elisa-kit",
		"complements": [
			"quest-5-hmc-dna-elisa-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"ez-dna-methylation-gold-kit",
		]
	},
	"5-mc-coating-buffer": {
		"cat_number": "D5325-1-15",
		"product_handle": "5-mc-coating-buffer",
		"complements": [
			"5-mc-elisa-buffer",
			"hrp-developer",
			"secondary-antibody",
		]
	},
	"5-mc-coating-buffer": {
		"cat_number": "D5325-1-30",
		"product_handle": "5-mc-coating-buffer",
		"complements": [
			"secondary-antibody",
			"5-mc-elisa-buffer",
			"control",
		]
	},
	"5-mc-elisa-buffer": {
		"cat_number": "D5325-2-250",
		"product_handle": "5-mc-elisa-buffer",
		"complements": [
			"hrp-developer",
			"5-mc-coating-buffer",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"secondary-antibody": {
		"cat_number": "D5325-3-15",
		"product_handle": "secondary-antibody",
		"complements": [
			"control",
		]
	},
	"secondary-antibody": {
		"cat_number": "D5325-3-30",
		"product_handle": "secondary-antibody",
		"complements": [
			"control",
			"96-well-elisa-plate",
		]
	},
	"control": {
		"cat_number": "D5325-5-1",
		"product_handle": "control",
		"complements": [
			"secondary-antibody",
			"5-mc-elisa-buffer",
		]
	},
	"control": {
		"cat_number": "D5325-5-2",
		"product_handle": "control",
		"complements": [
			"secondary-antibody",
		]
	},
	"5-mc-dna-elisa-kit": {
		"cat_number": "D5326",
		"product_handle": "5-mc-dna-elisa-kit",
		"complements": [
			"quest-5-hmc-dna-elisa-kit",
			"ez-dna-methylation-gold-kit",
		]
	},
	"5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set": {
		"cat_number": "D5405",
		"product_handle": "5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
		"complements": [
			"dna-degradase-plus",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"cytosine-dna-standard": {
		"cat_number": "D5405-1",
		"product_handle": "cytosine-dna-standard",
		"complements": [
			"5-methylcytosine-dna-standard",
			"dna-degradase-plus",
			"5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
		]
	},
	"5-methylcytosine-dna-standard": {
		"cat_number": "D5405-2",
		"product_handle": "5-methylcytosine-dna-standard",
		"complements": [
			"cytosine-dna-standard",
			"5-hydroxymethylcytosine-dna-standard",
			"ez-dna-methylation-gold-kit",
		]
	},
	"5-hydroxymethylcytosine-dna-standard": {
		"cat_number": "D5405-3",
		"product_handle": "5-hydroxymethylcytosine-dna-standard",
		"complements": [
			"5-methylcytosine-dna-standard",
			"cytosine-dna-standard",
			"universal-methylated-dna-standard",
		]
	},
	"quest-5-hmc-dna-elisa-kit": {
		"cat_number": "D5425",
		"product_handle": "quest-5-hmc-dna-elisa-kit",
		"complements": [
			"5-mc-dna-elisa-kit",
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
		]
	},
	"coating-buffer": {
		"cat_number": "D5425-1-15",
		"product_handle": "coating-buffer",
		"complements": [
			"hrp-developer",
			"10x-elisa-buffer",
			"5-mc-elisa-buffer",
		]
	},
	"coating-buffer": {
		"cat_number": "D5425-1-30",
		"product_handle": "coating-buffer",
		"complements": [
			"10x-elisa-buffer",
			"hrp-developer",
			"anti-dna-hrp-antibody-100x",
		]
	},
	"10x-elisa-buffer": {
		"cat_number": "D5425-2-30",
		"product_handle": "10x-elisa-buffer",
		"complements": [
			"hrp-developer",
			"coating-buffer",
			"5-mc-elisa-buffer",
		]
	},
	"10x-elisa-buffer": {
		"cat_number": "D5425-2-60",
		"product_handle": "10x-elisa-buffer",
		"complements": [
			"coating-buffer",
			"anti-dna-hrp-antibody-100x",
			"hrp-developer",
		]
	},
	"anti-dna-hrp-antibody-100x": {
		"cat_number": "D5425-3-100",
		"product_handle": "anti-dna-hrp-antibody-100x",
		"complements": [
			"control-e",
			"control-c",
			"control-b",
		]
	},
	"anti-dna-hrp-antibody-100x": {
		"cat_number": "D5425-3-200",
		"product_handle": "anti-dna-hrp-antibody-100x",
		"complements": [
			"anti-5-hydroxymethylcytosine-polyclonal-antibody",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"coating-buffer",
		]
	},
	"hrp-developer": {
		"cat_number": "D5425-4-15",
		"product_handle": "hrp-developer",
		"complements": [
			"5-mc-elisa-buffer",
			"5-mc-coating-buffer",
			"96-well-elisa-plate",
		]
	},
	"control-a": {
		"cat_number": "D5425-5-1",
		"product_handle": "control-a",
		"complements": [
			"control-d",
			"control-e",
			"control-b",
		]
	},
	"control-b": {
		"cat_number": "D5425-5-2",
		"product_handle": "control-b",
		"complements": [
			"control-d",
			"control-a",
			"control-e",
		]
	},
	"control-c": {
		"cat_number": "D5425-5-3",
		"product_handle": "control-c",
		"complements": [
			"control-d",
			"control-a",
			"control-e",
		]
	},
	"control-d": {
		"cat_number": "D5425-5-4",
		"product_handle": "control-d",
		"complements": [
			"control-c",
			"control-a",
			"control-e",
		]
	},
	"control-e": {
		"cat_number": "D5425-5-5",
		"product_handle": "control-e",
		"complements": [
			"control-d",
			"control-a",
			"control-c",
		]
	},
	"control-dna-set": {
		"cat_number": "D5425-5-C",
		"product_handle": "control-dna-set",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"ez-dna-methylation-kit",
			"zymo-spin-ic-columns",
		]
	},
	"quest-5-hmc-dna-elisa-kit": {
		"cat_number": "D5426",
		"product_handle": "quest-5-hmc-dna-elisa-kit",
		"complements": [
			"5-mc-dna-elisa-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"ez-dna-methylation-gold-kit",
		]
	},
	"rrhp-5-hmc-library-prep-kit": {
		"cat_number": "D5450",
		"product_handle": "rrhp-5-hmc-library-prep-kit",
		"complements": [
			"pico-methyl-seq-library-prep-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zr-small-rna-ladder",
		]
	},
	"rrhp-5-hmc-library-prep-kit": {
		"cat_number": "D5451",
		"product_handle": "rrhp-5-hmc-library-prep-kit",
		"complements": [
			"mix-and-go-competent-cells-tg1",
			"pico-methyl-seq-library-prep-kit",
			"zymotaq-dna-polymerase",
		]
	},
	"pico-methyl-seq-library-prep-kit": {
		"cat_number": "D5455",
		"product_handle": "pico-methyl-seq-library-prep-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"pico-methyl-seq-library-prep-kit": {
		"cat_number": "D5456",
		"product_handle": "pico-methyl-seq-library-prep-kit",
		"complements": [
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
			"frozen-ez-yeast-transformation-ii-kit",
		]
	},
	"zymo-seq-rrbs-library-kit": {
		"cat_number": "D5460",
		"product_handle": "zymo-seq-rrbs-library-kit",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"zymobiomics-dna-miniprep-kit",
			"zymo-spin-ic-columns",
		]
	},
	"zymo-seq-rrbs-library-kit": {
		"cat_number": "D5461",
		"product_handle": "zymo-seq-rrbs-library-kit",
		"complements": [
			"zymo-seq-udi-primer-sets",
			"dnase-i-set",
			"ez-dna-methylation-gold-kit",
		]
	},
	"quick-dna-fungal-bacterial-miniprep-kit": {
		"cat_number": "D6005",
		"product_handle": "quick-dna-fungal-bacterial-miniprep-kit",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"dna-clean-concentrator-5",
			"ez-dna-methylation-gold-kit",
		]
	},
	"quick-dna-fungal-bacterial-96-kit": {
		"cat_number": "D6006",
		"product_handle": "quick-dna-fungal-bacterial-96-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zr-96-dna-clean-amp-concentrator-5-deep-well",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"quick-dna-fungal-bacterial-microprep-kit": {
		"cat_number": "D6007",
		"product_handle": "quick-dna-fungal-bacterial-microprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-dna-fecal-soil-microbe-dna-miniprep-kit": {
		"cat_number": "D6010",
		"product_handle": "quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"quick-dna-fecal-soil-microbe-96-magbead-kit": {
		"cat_number": "D6010-FM",
		"product_handle": "quick-dna-fecal-soil-microbe-96-magbead-kit",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"zymobiomics-microbial-community-dna-standard",
			"g-dna-wash-buffer",
		]
	},
	"quick-dna-fecal-soil-microbe-96-kit": {
		"cat_number": "D6011",
		"product_handle": "quick-dna-fecal-soil-microbe-96-kit",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"rna-clean-concentrator-25",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"quick-dna-fecal-soil-microbe-96-magbead-kit": {
		"cat_number": "D6011-FM",
		"product_handle": "quick-dna-fecal-soil-microbe-96-magbead-kit",
		"complements": [
			"bashingbead-buffer",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"quick-dna-miniprep",
		]
	},
	"quick-dna-fecal-soil-microbe-microprep": {
		"cat_number": "D6012",
		"product_handle": "quick-dna-fecal-soil-microbe-microprep",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"quick-dna-fecal-soil-microbe-96-magbead-kit": {
		"cat_number": "D6012-FM",
		"product_handle": "quick-dna-fecal-soil-microbe-96-magbead-kit",
		"complements": [
			"rna-wash-buffer",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-miniprep",
		]
	},
	"quick-dna-tissue-insect-microprep-kit": {
		"cat_number": "D6015",
		"product_handle": "quick-dna-tissue-insect-microprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"quick-dna-tissue-insect-miniprep-kit": {
		"cat_number": "D6016",
		"product_handle": "quick-dna-tissue-insect-miniprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"quick-dna-tissue-insect-96-kit": {
		"cat_number": "D6017",
		"product_handle": "quick-dna-tissue-insect-96-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-rna-ffpe-miniprep",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"quick-dna-plant-seed-miniprep-kit": {
		"cat_number": "D6020",
		"product_handle": "quick-dna-plant-seed-miniprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"quick-dna-plant-seed-96-kit": {
		"cat_number": "D6021",
		"product_handle": "quick-dna-plant-seed-96-kit",
		"complements": [
			"quick-dna-plant-seed-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"onestep-pcr-inhibitor-removal-kit": {
		"cat_number": "D6030",
		"product_handle": "onestep-pcr-inhibitor-removal-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"onestep-pcr-inhibitor-removal-kit": {
		"cat_number": "D6035",
		"product_handle": "onestep-pcr-inhibitor-removal-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"dna-rna-shield",
		]
	},
	"quick-dna-hmw-magbead-kit": {
		"cat_number": "D6060",
		"product_handle": "quick-dna-hmw-magbead-kit",
		"complements": [
			"dna-rna-shield",
			"dna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"purerec-rnase-a-recombinant"
		],
		"cat_number_custom":[
			"E1019-20"
		]
	},
	"quick-dna-fungal-bacterial-midiprep-kit": {
		"cat_number": "D6105",
		"product_handle": "quick-dna-fungal-bacterial-midiprep-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"quick-dna-fecal-soil-microbe-midiprep": {
		"cat_number": "D6110",
		"product_handle": "quick-dna-fecal-soil-microbe-midiprep",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"zymopure-ii-plasmid-midiprep-kit",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"zymobiomics-microbial-community-standard": {
		"cat_number": "D6300",
		"product_handle": "zymobiomics-microbial-community-standard",
		"complements": [
			"zymobiomics-microbial-community-dna-standard",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"zymobiomics-microbial-community-dna-standard": {
		"cat_number": "D6305",
		"product_handle": "zymobiomics-microbial-community-dna-standard",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zymobiomics-microbial-community-dna-standard": {
		"cat_number": "D6306",
		"product_handle": "zymobiomics-microbial-community-dna-standard",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
		]
	},
	"zymobiomics-microbial-community-standard-ii-log-distribution": {
		"cat_number": "D6310",
		"product_handle": "zymobiomics-microbial-community-standard-ii-log-distribution",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-microbial-community-dna-standard-ii-log-distribution",
			"zymobiomics-microbial-community-dna-standard",
		]
	},
	"zymobiomics-microbial-community-dna-standard-ii-log-distribution": {
		"cat_number": "D6311",
		"product_handle": "zymobiomics-microbial-community-dna-standard-ii-log-distribution",
		"complements": [
			"zymobiomics-microbial-community-standard-ii-log-distribution",
			"zymobiomics-microbial-community-dna-standard",
		]
	},
	"zymobiomics-spike-in-control-i-high-microbial-load": {
		"cat_number": "D6320",
		"product_handle": "zymobiomics-spike-in-control-i-high-microbial-load",
		"complements": [
			"zymobiomics-spike-in-control-ii-low-microbial-load",
			"zymobiomics-microbial-community-standard",
			"dna-rna-shield",
		]
	},
	"zymobiomics-spike-in-control-i-high-microbial-load": {
		"cat_number": "D6320-10",
		"product_handle": "zymobiomics-spike-in-control-i-high-microbial-load",
		"complements": [
			"zymobiomics-spike-in-control-ii-low-microbial-load",
			"zymobiomics-microbial-community-standard",
			"zymobiomics-microbial-community-standard-ii-log-distribution",
		]
	},
	"zymobiomics-spike-in-control-ii-low-microbial-load": {
		"cat_number": "D6321",
		"product_handle": "zymobiomics-spike-in-control-ii-low-microbial-load",
		"complements": [
			"zymobiomics-spike-in-control-i-high-microbial-load",
			"zymobiomics-microbial-community-standard",
			"dna-rna-shield",
		]
	},
	"zymobiomics-spike-in-control-ii-low-microbial-load": {
		"cat_number": "D6321-10",
		"product_handle": "zymobiomics-spike-in-control-ii-low-microbial-load",
		"complements": [
			"zymobiomics-spike-in-control-i-high-microbial-load",
			"zymobiomics-microbial-community-standard",
			"zymobiomics-microbial-community-dna-standard",
		]
	},
	"zymobiomics-hmw-dna-standard": {
		"cat_number": "D6322",
		"product_handle": "zymobiomics-hmw-dna-standard",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-microbial-community-dna-standard-ii-log-distribution",
			"zymobiomics-microbial-community-dna-standard",
		]
	},
	"zymobiomics-fecal-reference-with-trumatrix-technology": {
		"cat_number": "D6323",
		"product_handle": "zymobiomics-fecal-reference-with-trumatrix-technology",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-microbial-community-dna-standard",
			"zymobiomics-gut-microbiome-standard",
		]
	},
	"zymobiomics-gut-microbiome-standard": {
		"cat_number": "D6331",
		"product_handle": "zymobiomics-gut-microbiome-standard",
		"complements": [
			"zymobiomics-microbial-community-standard",
			"zymobiomics-microbial-community-dna-standard",
		]
	},
	"quick-16s-ngs-library-prep-kit": {
		"cat_number": "D6400",
		"product_handle": "quick-16s-ngs-library-prep-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"zymobiomics-microbial-community-standard",
			"dna-clean-concentrator-5",
		]
	},
	"quick-16s-primer-set-v1-v2": {
		"cat_number": "D6405-1-400",
		"product_handle": "quick-16s-primer-set-v1-v2",
		"complements": [
			"quick-16s-primer-set-v3-v4",
			"quick-16s-ngs-library-prep-kit",
			"human-methylated-non-methylated-dna-set-dna-w-primers",
		]
	},
	"quick-16s-primer-set-v3-v4": {
		"cat_number": "D6405-2-400",
		"product_handle": "quick-16s-primer-set-v3-v4",
		"complements": [
			"quick-16s-primer-set-v1-v2",
			"quick-16s-ngs-library-prep-kit",
			"zymotaq-qpcr-premix",
		]
	},
	"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi": {
		"cat_number": "D6421",
		"product_handle": "quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"complements": [
			"quick-its-plus-ngs-library-prep-kit-udi",
			"quick-16s-ngs-library-prep-kit",
			"hostzero-microbial-dna-kit",
		]
	},
	"quick-dna-rna-miniprep": {
		"cat_number": "D7001",
		"product_handle": "quick-dna-rna-miniprep",
		"complements": [
			"dnase-i-set",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
		]
	},
	"dna-rna-lysis-buffer": {
		"cat_number": "D7001-1-200",
		"product_handle": "dna-rna-lysis-buffer",
		"complements": [
			"dna-rna-prep-buffer",
			"dna-rna-wash-buffer-concentrate",
			"silicon-a-plate",
		]
	},
	"dna-rna-lysis-buffer": {
		"cat_number": "D7001-1-50",
		"product_handle": "dna-rna-lysis-buffer",
		"complements": [
			"dna-rna-wash-buffer-concentrate",
			"dna-rna-prep-buffer",
			"dnase-i-set",
		]
	},
	"quick-dna-rna-miniprep-plus-kit": {
		"cat_number": "D7003",
		"product_handle": "quick-dna-rna-miniprep-plus-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-dna-rna-miniprep-plus-kit": {
		"cat_number": "D7003T",
		"product_handle": "quick-dna-rna-miniprep-plus-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"ez-dna-methylation-gold-kit",
		]
	},
	"quick-dna-rna-microprep-plus-kit": {
		"cat_number": "D7005",
		"product_handle": "quick-dna-rna-microprep-plus-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"dna-rna-shield",
		]
	},
	"quick-dna-rna-microprep-plus-kit": {
		"cat_number": "D7005T",
		"product_handle": "quick-dna-rna-microprep-plus-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"dna-rna-binding-buffer": {
		"cat_number": "D7010-1-10",
		"product_handle": "dna-rna-binding-buffer",
		"complements": [
			"m-wash-buffer",
			"oligo-binding-buffer",
			"dna-rna-prep-buffer",
		]
	},
	"dna-rna-binding-buffer": {
		"cat_number": "D7010-1-25",
		"product_handle": "dna-rna-binding-buffer",
		"complements": [
			"dna-rna-prep-buffer",
			"dna-rna-wash-buffer-concentrate",
		]
	},
	"dna-rna-binding-buffer": {
		"cat_number": "D7010-1-50",
		"product_handle": "dna-rna-binding-buffer",
		"complements": [
			"dna-rna-wash-buffer-concentrate",
			"rna-clean-concentrator-5",
			"dna-wash-buffer-concentrate",
		]
	},
	"dna-rna-prep-buffer": {
		"cat_number": "D7010-2-10",
		"product_handle": "dna-rna-prep-buffer",
		"complements": [
			"dna-digestion-buffer",
			"m-binding-buffer-gold",
			"m-elution-buffer",
		]
	},
	"dna-rna-prep-buffer": {
		"cat_number": "D7010-2-25",
		"product_handle": "dna-rna-prep-buffer",
		"complements": [
			"dna-rna-wash-buffer-concentrate",
			"dnase-i-set",
		]
	},
	"dna-rna-prep-buffer": {
		"cat_number": "D7010-2-50",
		"product_handle": "dna-rna-prep-buffer",
		"complements": [
			"dna-rna-wash-buffer-concentrate",
			"dnase-i-set",
			"dna-rna-lysis-buffer",
		]
	},
	"dna-rna-wash-buffer-concentrate": {
		"cat_number": "D7010-3-12",
		"product_handle": "dna-rna-wash-buffer-concentrate",
		"complements": [
			"dna-rna-prep-buffer",
			"dna-rna-binding-buffer",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"dna-rna-wash-buffer-concentrate": {
		"cat_number": "D7010-3-24",
		"product_handle": "dna-rna-wash-buffer-concentrate",
		"complements": [
			"dna-rna-prep-buffer",
			"dnase-i-set",
			"dna-rna-lysis-buffer",
		]
	},
	"dna-rna-wash-buffer-concentrate": {
		"cat_number": "D7010-3-6",
		"product_handle": "dna-rna-wash-buffer-concentrate",
		"complements": [
			"dnase-i-set",
			"dna-rna-prep-buffer",
			"rna-wash-buffer",
		]
	},
	"quick-dna-rna-viral-kit": {
		"cat_number": "D7020",
		"product_handle": "quick-dna-rna-viral-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"dna-rna-shield",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"viral-dna-rna-buffer": {
		"cat_number": "D7020-1-100",
		"product_handle": "viral-dna-rna-buffer",
		"complements": [
			"magbead-dna-rna-wash-2",
			"magbead-dna-rna-wash-1",
			"dna-rna-shield",
		]
	},
	"viral-dna-rna-buffer": {
		"cat_number": "D7020-1-25",
		"product_handle": "viral-dna-rna-buffer",
		"complements": [
			"viral-rna-wash-buffer-concentrate",
			"dnase-rnase-free-water",
			"m-elution-buffer",
		]
	},
	"quick-dna-rna-viral-kit": {
		"cat_number": "D7021",
		"product_handle": "quick-dna-rna-viral-kit",
		"complements": [
			"dna-rna-shield",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"quick-dna-rna-viral-96-kit": {
		"cat_number": "D7022",
		"product_handle": "quick-dna-rna-viral-96-kit",
		"complements": [
			"direct-zol-rna-miniprep-plus-kits",
			"dna-rna-shield",
			"select-a-size-dna-clean-concentrator-kit",
		]
	},
	"quick-dna-rna-viral-96-kit": {
		"cat_number": "D7023",
		"product_handle": "quick-dna-rna-viral-96-kit",
		"complements": [
			"dna-rna-shield",
			"dnase-i-set",
			"zymo-spin-ic-columns",
		]
	},
	"zymolyase": {
		"complements": [
			"zymoprep-yeast-plasmid-miniprep-ii",
			"zymoclean-gel-dna-recovery-kit",
			"dna-clean-concentrator-5"
		]
	},
	"dnase-i-set": {
		"cat_number": "E1010",
		"product_handle": "dnase-i-set",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
		]
	},
	"dna-digestion-buffer": {
		"cat_number": "E1010-1-16",
		"product_handle": "dna-digestion-buffer",
		"complements": [
			"rna-wash-buffer",
			"rna-prep-buffer",
			"dnase-i-set",
		]
	},
	"dna-digestion-buffer": {
		"cat_number": "E1010-1-4",
		"product_handle": "dna-digestion-buffer",
		"complements": [
		]
	},
	"femto-bacterial-dna-quantification-kit": {
		"cat_number": "E2006",
		"product_handle": "femto-bacterial-dna-quantification-kit",
		"complements": [
			"femto-fungal-dna-quantification-kit",
			"femto-human-dna-quantification-kit",
			"zymobiomics-microbial-community-standard",
		]
	},
	"femto-bacterial-qpcr-premix": {
		"cat_number": "E2006-1",
		"product_handle": "femto-bacterial-qpcr-premix",
		"complements": [
			"femto-bacterial-dna-quantification-kit",
			"femto-fungal-qpcr-premix",
			"femto-human-qpcr-premix",
		]
	},
	"bacterial-dna-standards-and-no-template-control": {
		"cat_number": "E2006-2",
		"product_handle": "bacterial-dna-standards-and-no-template-control",
		"complements": [
			"femto-bacterial-dna-quantification-kit",
			"5-mc-dna-elisa-kit",
			"zymobiomics-microbial-community-standard",
		]
	},
	"femto-fungal-dna-quantification-kit": {
		"cat_number": "E2007",
		"product_handle": "femto-fungal-dna-quantification-kit",
		"complements": [
			"femto-bacterial-dna-quantification-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"femto-fungal-qpcr-premix": {
		"cat_number": "E2007-1",
		"product_handle": "femto-fungal-qpcr-premix",
		"complements": [
			"femto-bacterial-qpcr-premix",
			"femto-fungal-dna-quantification-kit",
			"femto-bacterial-dna-quantification-kit",
		]
	},
	"fungal-dna-standards-and-no-template-control": {
		"cat_number": "E2007-2",
		"product_handle": "fungal-dna-standards-and-no-template-control",
		"complements": [
			"femto-bacterial-dna-quantification-kit",
			"bacterial-dna-standards-and-no-template-control",
			"ez-dna-methylation-lightning-kit",
		]
	},
	"5-fluoroorotic-acid": {
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-rna-fungal-bacterial-microprep-kit",
			"frozen-ez-yeast-transformation-ii-kit"
		]
	},
	"iptg-isopropyl-b-d-thiogalactopyranoside": {
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit-sample",
			"ampicillin-sodium-solution",
			"zymopure-ii-plasmid-miniprep-kit"
		]
	},
	"expansion-broth-eb": {
		"complements": [
			"tetracycline-hydrochloride-solution-reagent-grade",
			"overexpression-broth-ob",
			"mix-and-go-competent-cells-xjbde3-autolysis"
		]
	},
	"overexpression-broth-ob": {
		"complements": [
			"tetracycline-hydrochloride-solution-reagent-grade",
			"expansion-broth-eb",
			"mix-and-go-competent-cells-xjbde3-autolysis"
		]
	},
	"zymobroth": {
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"dna-clean-concentrator-5",
			"zymopure-ii-plasmid-midiprep-kit"
		]
	},
	"zr-50-bp-dna-marker": {
		"cat_number": "M5001-200",
		"product_handle": "zr-50-bp-dna-marker",
		"complements": [
			"zr-1-kb-dna-marker",
			"zr-100-bp-dna-marker",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zr-50-bp-dna-marker": {
		"cat_number": "M5001-50",
		"product_handle": "zr-50-bp-dna-marker",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"dna-clean-concentrator-5",
			"zr-100-bp-dna-marker",
		]
	},
	"zr-100-bp-dna-marker": {
		"cat_number": "M5002-200",
		"product_handle": "zr-100-bp-dna-marker",
		"complements": [
			"zr-1-kb-dna-marker",
			"dnase-i-set",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"zr-100-bp-dna-marker": {
		"cat_number": "M5002-50",
		"product_handle": "zr-100-bp-dna-marker",
		"complements": [
			"zr-1-kb-dna-marker",
			"zr-50-bp-dna-marker",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zr-1-kb-dna-marker": {
		"cat_number": "M5003-200",
		"product_handle": "zr-1-kb-dna-marker",
		"complements": [
			"zr-100-bp-dna-marker",
			"zymoclean-gel-dna-recovery-kit",
			"zr-50-bp-dna-marker",
		]
	},
	"zr-1-kb-dna-marker": {
		"cat_number": "M5003-50",
		"product_handle": "zr-1-kb-dna-marker",
		"complements": [
			"zr-100-bp-dna-marker",
			"quick-dna-miniprep-plus-kit",
			"zyppy-plasmid-miniprep-kit",
		]
	},
	"zr-50-bp-dna-marker": {
		"cat_number": "M5004-50",
		"product_handle": "zr-50-bp-dna-marker",
		"complements": [
			"zr-100-bp-dna-marker",
			"zr-1-kb-dna-marker",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zr-100-bp-dna-marker": {
		"cat_number": "M5005-50",
		"product_handle": "zr-100-bp-dna-marker",
		"complements": [
			"zr-1-kb-dna-marker",
			"zr-50-bp-dna-marker",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zr-1-kb-dna-marker": {
		"cat_number": "M5006-50",
		"product_handle": "zr-1-kb-dna-marker",
		"complements": [
			"zr-100-bp-dna-marker",
			"zr-50-bp-dna-marker",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"his-spin-protein-miniprep": {
		"cat_number": "P2001",
		"product_handle": "his-spin-protein-miniprep",
		"complements": [
			"dna-clean-concentrator-5",
			"ez-dna-methylation-gold-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"his-spin-protein-miniprep": {
		"cat_number": "P2002",
		"product_handle": "his-spin-protein-miniprep",
		"complements": [
			"dna-clean-concentrator-5",
			"ez-dna-methylation-gold-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"zymo-spin-p1-columns": {
		"cat_number": "P2003-1",
		"product_handle": "zymo-spin-p1-columns",
		"complements": [
			"his-affinity-gel",
			"mix-and-go-e-coli-transformation-kit",
			"collection-tubes",
		]
	},
	"his-affinity-gel": {
		"cat_number": "P2003-2",
		"product_handle": "his-affinity-gel",
		"complements": [
			"zymo-spin-p1-columns",
			"overexpression-broth-ob",
			"expansion-broth-eb",
		]
	},
	"his-binding-buffer": {
		"cat_number": "P2003-3",
		"product_handle": "his-binding-buffer",
		"complements": [
			"his-elution-buffer",
			"his-wash-buffer",
			"his-affinity-gel",
		]
	},
	"his-wash-buffer": {
		"cat_number": "P2003-4",
		"product_handle": "his-wash-buffer",
		"complements": [
			"his-binding-buffer",
			"his-elution-buffer",
			"rna-clean-concentrator-5",
		]
	},
	"his-elution-buffer": {
		"cat_number": "P2003-5",
		"product_handle": "his-elution-buffer",
		"complements": [
			"his-binding-buffer",
			"his-wash-buffer",
			"his-affinity-gel",
		]
	},
	"strep-spin-protein-miniprep": {
		"cat_number": "P2004",
		"product_handle": "strep-spin-protein-miniprep",
		"complements": [
			"his-spin-protein-miniprep",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-microprep-kits",
		]
	},
	"strep-tactin-xt-superflow-50": {
		"cat_number": "P2004-1-5",
		"product_handle": "strep-tactin-xt-superflow-50",
		"complements": [
			"strep-elution-buffer",
			"zymoprep-yeast-plasmid-miniprep-ii",
			"strep-wash-buffer",
		]
	},
	"strep-wash-buffer": {
		"cat_number": "P2004-2-65",
		"product_handle": "strep-wash-buffer",
		"complements": [
			"strep-elution-buffer",
			"strep-tactin-xt-superflow-50",
			"strep-spin-protein-miniprep",
		]
	},
	"strep-elution-buffer": {
		"cat_number": "P2004-3-30",
		"product_handle": "strep-elution-buffer",
		"complements": [
			"strep-tactin-xt-superflow-50",
			"strep-wash-buffer",
			"zr-bashingbead-lysis-filtration-tubes",
		]
	},
	"strep-spin-protein-miniprep": {
		"cat_number": "P2005",
		"product_handle": "strep-spin-protein-miniprep",
		"complements": [
			"dna-rna-shield",
			"zymo-spin-ic-columns",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"mbp-spin-protein-miniprep": {
		"cat_number": "P2006",
		"product_handle": "mbp-spin-protein-miniprep",
		"complements": [
			"direct-zol-rna-microprep-kits",
			"ez-dna-methylation-gold-kit",
			"frozen-ez-yeast-transformation-ii-kit",
		]
	},
	"amylose-resin": {
		"cat_number": "P2006-1-5",
		"product_handle": "amylose-resin",
		"complements": [
			"zymoprep-yeast-plasmid-miniprep-ii",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"mbp-wash-buffer": {
		"cat_number": "P2006-2-70",
		"product_handle": "mbp-wash-buffer",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"rna-clean-concentrator-5",
			"dna-clean-concentrator-5",
		]
	},
	"mbp-elution-buffer": {
		"cat_number": "P2006-3-20",
		"product_handle": "mbp-elution-buffer",
		"complements": [
			"mbp-wash-buffer",
			"dna-rna-shield",
			"direct-zol-rna-miniprep-plus-kits",
		]
	},
	"mbp-spin-protein-miniprep": {
		"cat_number": "P2007",
		"product_handle": "mbp-spin-protein-miniprep",
		"complements": [
			"direct-zol-rna-microprep-kits",
			"mix-and-go-e-coli-transformation-kit",
			"rna-clean-concentrator-5",
		]
	},
	"yeastar-rna-kit": {
		"complements": [
			"yeastar-genomic-dna-kit",
			"zymolyase",
			"zymoprep-yeast-plasmid-miniprep-ii",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"pinpoint-slide-rna-isolation-system": {
		"cat_number": "R1003",
		"product_handle": "pinpoint-slide-rna-isolation-system",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"rna-wash-buffer": {
		"cat_number": "R1003-3-12",
		"product_handle": "rna-wash-buffer",
		"complements": [
			"direct-zol-rna-prewash-concentrate",
			"rna-prep-buffer",
			"dnase-i-set",
		]
	},
	"rna-wash-buffer": {
		"cat_number": "R1003-3-24",
		"product_handle": "rna-wash-buffer",
		"complements": [
			"rna-prep-buffer",
			"dnase-i-set",
		]
	},
	"rna-wash-buffer": {
		"cat_number": "R1003-3-48",
		"product_handle": "rna-wash-buffer",
		"complements": [
			"rna-prep-buffer",
			"direct-zol-rna-prewash-concentrate",
			"dnase-i-set",
		]
	},
	"rna-wash-buffer": {
		"cat_number": "R1003-3-6",
		"product_handle": "rna-wash-buffer",
		"complements": [
			"dnase-i-set",
			"dna-wash-buffer-concentrate",
			"dnase-rnase-free-water",
		]
	},
	"pinpoint-slide-rna-isolation-system": {
		"cat_number": "R1007",
		"product_handle": "pinpoint-slide-rna-isolation-system",
		"complements": [
			"pinpoint-slide-dna-isolation-system",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"ez-dna-methylation-gold-kit",
		]
	},
	"quick-rna-ffpe-miniprep": {
		"cat_number": "R1008",
		"product_handle": "quick-rna-ffpe-miniprep",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"quick-dna-miniprep-plus-kit",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-dna-rna-ffpe-miniprep-kit": {
		"cat_number": "R1009",
		"product_handle": "quick-dna-rna-ffpe-miniprep-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"zymoclean-gel-rna-recovery-kit": {
		"cat_number": "R1011",
		"product_handle": "zymoclean-gel-rna-recovery-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-5": {
		"cat_number": "R1013",
		"product_handle": "rna-clean-concentrator-5",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-binding-buffer": {
		"cat_number": "R1013-2-100",
		"product_handle": "rna-binding-buffer",
		"complements": [
			"rna-prep-buffer",
			"rna-wash-buffer",
		]
	},
	"rna-binding-buffer": {
		"cat_number": "R1013-2-25",
		"product_handle": "rna-binding-buffer",
		"complements": [
			"rna-prep-buffer",
			"rna-wash-buffer",
			"dna-elution-buffer",
		]
	},
	"rna-binding-buffer": {
		"cat_number": "R1013-2-50",
		"product_handle": "rna-binding-buffer",
		"complements": [
			"rna-wash-buffer",
			"rna-prep-buffer",
		]
	},
	"rna-clean-concentrator-5": {
		"cat_number": "R1014",
		"product_handle": "rna-clean-concentrator-5",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-5": {
		"cat_number": "R1015",
		"product_handle": "rna-clean-concentrator-5",
		"complements": [
			"dna-clean-concentrator-5",
			"rna-clean-concentrator-25",
			"direct-zol-rna-miniprep-kits",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-5": {
		"cat_number": "R1016",
		"product_handle": "rna-clean-concentrator-5",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-25": {
		"cat_number": "R1017",
		"product_handle": "rna-clean-concentrator-25",
		"complements": [
			"rna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-25": {
		"cat_number": "R1018",
		"product_handle": "rna-clean-concentrator-25",
		"complements": [
			"dnase-i-set",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-100": {
		"cat_number": "R1019",
		"product_handle": "rna-clean-concentrator-100",
		"complements": [
			"rna-clean-concentrator-25",
			"dnase-i-set",
			"dna-clean-concentrator-5",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zr-rna-buffer": {
		"cat_number": "R1020-1-100",
		"product_handle": "zr-rna-buffer",
		"complements": [
			"rna-wash-buffer",
			"quick-dna-miniprep-plus-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"zr-rna-buffer": {
		"cat_number": "R1020-1-200",
		"product_handle": "zr-rna-buffer",
		"complements": [
			"rna-pre-wash-buffer",
			"rna-wash-buffer",
		]
	},
	"zr-rna-buffer": {
		"cat_number": "R1020-1-50",
		"product_handle": "zr-rna-buffer",
		"complements": [
			"quick-rna-microprep-kit",
			"rna-prep-buffer",
			"rna-binding-buffer",
		]
	},
	"rna-pre-wash-buffer": {
		"cat_number": "R1020-2-100",
		"product_handle": "rna-pre-wash-buffer",
		"complements": [
			"rna-wash-buffer",
			"dna-clean-concentrator-5",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"rna-pre-wash-buffer": {
		"cat_number": "R1020-2-12",
		"product_handle": "rna-pre-wash-buffer",
		"complements": [
			"rna-wash-buffer",
			"dna-rna-lysis-buffer",
			"dnase-rnase-free-water",
		]
	},
	"rna-pre-wash-buffer": {
		"cat_number": "R1020-2-25",
		"product_handle": "rna-pre-wash-buffer",
		"complements": [
			"rna-wash-buffer",
			"quick-dna-plant-seed-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"rna-pre-wash-buffer": {
		"cat_number": "R1020-2-50",
		"product_handle": "rna-pre-wash-buffer",
		"complements": [
			"rna-lysis-buffer",
			"rna-wash-buffer",
			"dnase-i-set",
		]
	},
	"rbc-lysis-buffer": {
		"cat_number": "R1022-2-100",
		"product_handle": "rbc-lysis-buffer",
		"complements": [
			"quick-dna-miniprep",
			"zymoclean-gel-dna-recovery-kit",
			"dnase-i-set",
		]
	},
	"rbc-lysis-buffer": {
		"cat_number": "R1022-2-50",
		"product_handle": "rbc-lysis-buffer",
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"zymobiomics-dna-miniprep-kit",
			"rna-wash-buffer",
		]
	},
	"quick-rna-viral-kit": {
		"cat_number": "R1034",
		"product_handle": "quick-rna-viral-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"viral-rna-buffer": {
		"cat_number": "R1034-1-100",
		"product_handle": "viral-rna-buffer",
		"complements": [
			"viral-rna-wash-buffer-concentrate",
			"zymo-spin-ic-columns",
			"dna-rna-shield",
		]
	},
	"viral-rna-buffer": {
		"cat_number": "R1034-1-50",
		"product_handle": "viral-rna-buffer",
		"complements": [
			"viral-rna-wash-buffer-concentrate",
			"dnase-rnase-free-water",
			"dna-rna-shield",
		]
	},
	"viral-rna-wash-buffer-concentrate": {
		"cat_number": "R1034-2-24",
		"product_handle": "viral-rna-wash-buffer-concentrate",
		"complements": [
			"viral-rna-buffer",
			"zymo-spin-ic-columns",
			"collection-tubes",
		]
	},
	"viral-rna-wash-buffer-concentrate": {
		"cat_number": "R1034-2-48",
		"product_handle": "viral-rna-wash-buffer-concentrate",
		"complements": [
			"viral-rna-buffer",
			"zymo-spin-ic-columns",
			"collection-tubes",
		]
	},
	"viral-rna-wash-buffer-concentrate": {
		"cat_number": "R1034-2-6",
		"product_handle": "viral-rna-wash-buffer-concentrate",
		"complements": [
			"dnase-rnase-free-water",
			"dna-elution-buffer",
			"m-elution-buffer",
		]
	},
	"quick-rna-viral-kit": {
		"cat_number": "R1035",
		"product_handle": "quick-rna-viral-kit",
		"complements": [
			"dna-rna-shield",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"zr-urine-rna-isolation-kit": {
		"cat_number": "R1038",
		"product_handle": "zr-urine-rna-isolation-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"mix-and-go-e-coli-transformation-kit",
			"chip-dna-clean-concentrator",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"urine-rna-buffer": {
		"cat_number": "R1038-2-20",
		"product_handle": "urine-rna-buffer",
		"complements": [
			"dnase-rnase-free-water",
			"m-desulphonation-buffer",
			"m-wash-buffer",
		]
	},
	"urine-rna-buffer": {
		"cat_number": "R1038-2-50",
		"product_handle": "urine-rna-buffer",
		"complements": [
			"zrc-gf-filter",
			"mix-and-go-2x-stock-wash-buffer",
			"rna-wash-buffer",
		]
	},
	"zr-urine-rna-isolation-kit": {
		"cat_number": "R1039",
		"product_handle": "zr-urine-rna-isolation-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-viral-96-kit": {
		"cat_number": "R1040",
		"product_handle": "quick-rna-viral-96-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"dna-rna-shield",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"quick-rna-viral-96-kit": {
		"cat_number": "R1041",
		"product_handle": "quick-rna-viral-96-kit",
		"complements": [
			"quick-rna-viral-kit",
			"collection-plate",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-dna-rna-pathogen-miniprep": {
		"cat_number": "R1042",
		"product_handle": "quick-dna-rna-pathogen-miniprep",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-rna-shield",
			"dna-clean-concentrator-5",
		]
	},
	"pathogen-dna-rna-buffer": {
		"cat_number": "R1042-1-100",
		"product_handle": "pathogen-dna-rna-buffer",
		"complements": [
			"pathogen-dna-rna-wash-buffer-concentrate",
			"zymobiomics-dnase-rnase-free-water",
			"dna-elution-buffer",
		]
	},
	"pathogen-dna-rna-buffer": {
		"cat_number": "R1042-1-50",
		"product_handle": "pathogen-dna-rna-buffer",
		"complements": [
			"dna-elution-buffer",
			"dna-rna-shield",
			"m-dilution-buffer-gold",
		]
	},
	"pathogen-dna-rna-wash-buffer-concentrate": {
		"cat_number": "R1042-2-48",
		"product_handle": "pathogen-dna-rna-wash-buffer-concentrate",
		"complements": [
			"pathogen-dna-rna-buffer",
			"zymobiomics-dnase-rnase-free-water",
			"collection-tubes",
		]
	},
	"pathogen-dna-rna-wash-buffer-concentrate": {
		"cat_number": "R1042-2-6",
		"product_handle": "pathogen-dna-rna-wash-buffer-concentrate",
		"complements": [
			"dnase-rnase-free-water",
			"dna-rna-shield",
			"pathogen-dna-rna-buffer",
		]
	},
	"quick-dna-rna-pathogen-miniprep": {
		"cat_number": "R1043",
		"product_handle": "quick-dna-rna-pathogen-miniprep",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"dna-rna-shield",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"quick-rna-microprep-kit": {
		"cat_number": "R1050",
		"product_handle": "quick-rna-microprep-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"quick-rna-microprep-kit": {
		"cat_number": "R1051",
		"product_handle": "quick-rna-microprep-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"quick-rna-miniprep-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-96-kit": {
		"cat_number": "R1052",
		"product_handle": "quick-rna-96-kit",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-rna-microprep-kit",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-96-kit": {
		"cat_number": "R1053",
		"product_handle": "quick-rna-96-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-miniprep-kit": {
		"cat_number": "R1054",
		"product_handle": "quick-rna-miniprep-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-miniprep-kit": {
		"cat_number": "R1055",
		"product_handle": "quick-rna-miniprep-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-midiprep-kit": {
		"cat_number": "R1056",
		"product_handle": "quick-rna-midiprep-kit",
		"complements": [
			"zymopure-ii-plasmid-midiprep-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-miniprep-plus-kit": {
		"cat_number": "R1057",
		"product_handle": "quick-rna-miniprep-plus-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"quick-rna-miniprep-plus-kit": {
		"cat_number": "R1057T",
		"product_handle": "quick-rna-miniprep-plus-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"dnase-i-set",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"quick-rna-miniprep-plus-kit": {
		"cat_number": "R1058",
		"product_handle": "quick-rna-miniprep-plus-kit",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-rna-shield",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-cfrna-serum-plasma-kit": {
		"cat_number": "R1059",
		"product_handle": "quick-cfrna-serum-plasma-kit",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-rna-shield",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-lysis-buffer": {
		"cat_number": "R1060-1-100",
		"product_handle": "rna-lysis-buffer",
		"complements": [
			"rna-prep-buffer",
			"rna-wash-buffer",
			"dnase-i-set",
		]
	},
	"rna-lysis-buffer": {
		"cat_number": "R1060-1-50",
		"product_handle": "rna-lysis-buffer",
		"complements": [
			"rna-prep-buffer",
			"rna-wash-buffer",
		]
	},
	"rna-prep-buffer": {
		"cat_number": "R1060-2-10",
		"product_handle": "rna-prep-buffer",
		"complements": [
			"rna-wash-buffer",
			"dnase-rnase-free-water",
		]
	},
	"rna-prep-buffer": {
		"cat_number": "R1060-2-100",
		"product_handle": "rna-prep-buffer",
		"complements": [
			"rna-wash-buffer",
			"dnase-i-set",
			"zymo-spin-ic-columns",
		]
	},
	"rna-prep-buffer": {
		"cat_number": "R1060-2-25",
		"product_handle": "rna-prep-buffer",
		"complements": [
			"rna-wash-buffer",
			"dnase-i-set",
		]
	},
	"rna-prep-buffer": {
		"cat_number": "R1060-2-50",
		"product_handle": "rna-prep-buffer",
		"complements": [
			"dnase-i-set",
			"rna-wash-buffer",
		]
	},
	"zr-small-rna-page-recovery-kit": {
		"cat_number": "R1070",
		"product_handle": "zr-small-rna-page-recovery-kit",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"ez-dna-methylation-gold-kit",
			"dna-clean-concentrator-5",
		]
	},
	"rna-recovery-buffer": {
		"cat_number": "R1070-1-10",
		"product_handle": "rna-recovery-buffer",
		"complements": [
			"rna-max-buffer",
			"m-dilution-buffer-gold",
		]
	},
	"rna-max-buffer": {
		"cat_number": "R1070-2-20",
		"product_handle": "rna-max-buffer",
		"complements": [
			"rna-recovery-buffer",
			"rna-prep-buffer",
			"rna-wash-buffer",
		]
	},
	"quick-cfdna-rna-serum-plasma-kit": {
		"cat_number": "R1072",
		"product_handle": "quick-cfdna-rna-serum-plasma-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"rna-clean-concentrator-96": {
		"cat_number": "R1080",
		"product_handle": "rna-clean-concentrator-96",
		"complements": [
			"dnase-i-set",
			"rna-clean-concentrator-5",
			"rna-clean-concentrator-25",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-magbead": {
		"cat_number": "R1081",
		"product_handle": "rna-clean-concentrator-magbead",
		"complements": [
			"quick-rna-magbead",
			"dna-rna-shield",
			"zymo-spin-ic-columns",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"rna-clean-concentrator-magbead": {
		"cat_number": "R1082",
		"product_handle": "rna-clean-concentrator-magbead",
		"complements": [
			"dnase-i-set",
			"rna-clean-concentrator-96",
			"rna-clean-concentrator-25",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zr-small-rna-ladder": {
		"cat_number": "R1090",
		"product_handle": "zr-small-rna-ladder",
		"complements": [
			"zr-small-rna-page-recovery-kit",
			"mix-and-go-competent-cells-tg1",
			"universal-methylated-dna-standard",
		]
	},
	"dna-rna-shield": {
		"cat_number": "R1100-250",
		"product_handle": "dna-rna-shield",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"dna-rna-shield": {
		"cat_number": "R1100-50",
		"product_handle": "dna-rna-shield",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		]
	},
	"bunny-wipe-fecal-sample-collector": {
		"cat_number": "R1101",
		"product_handle": "bunny-wipe-fecal-sample-collector",
		"complements": [
			"feces-catcher",
			"dna-rna-shield",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"feces-catcher": {
		"cat_number": "R1101-1-10",
		"product_handle": "feces-catcher",
		"complements": [
			"bunny-wipe-fecal-sample-collector",
			"dna-rna-shield",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"coloff-stool-collection-device": {
		"cat_number": "R1101-2-5",
		"product_handle": "coloff-stool-collection-device",
		"complements": [
			"feces-catcher",
			"bunny-wipe-fecal-sample-collector",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"dna-rna-shield-lysis-and-collection-tubes": {
		"cat_number": "R1102",
		"product_handle": "dna-rna-shield-lysis-and-collection-tubes",
		"complements": [
			"dna-rna-shield",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zymobiomics-dna-miniprep-kit",
		]
	},
	"dna-rna-shield-lysis-and-collection-tubes": {
		"cat_number": "R1103",
		"product_handle": "dna-rna-shield-lysis-and-collection-tubes",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
			"rna-clean-concentrator-5",
		]
	},
	"dna-rna-shield-lysis-and-collection-tubes": {
		"cat_number": "R1104",
		"product_handle": "dna-rna-shield-lysis-and-collection-tubes",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
			"select-a-size-dna-clean-concentrator-kit",
		]
	},
	"dna-rna-shield-lysis-and-collection-tubes": {
		"cat_number": "R1105",
		"product_handle": "dna-rna-shield-lysis-and-collection-tubes",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-rna-shield",
			"dnase-i-set",
		]
	},
	"dna-rna-shield-collection-tube-w-swab": {
		"cat_number": "R1106",
		"product_handle": "dna-rna-shield-collection-tube-w-swab",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"dna-rna-shield",
		]
	},
	"dna-rna-shield-collection-tube-w-swab": {
		"cat_number": "R1107",
		"product_handle": "dna-rna-shield-collection-tube-w-swab",
		"complements": [
			"dna-rna-shield",
			"zymobiomics-dna-miniprep-kit",
			"bunny-wipe-fecal-sample-collector",
		]
	},
	"dna-rna-shield-collection-tube-w-swab": {
		"cat_number": "R1108",
		"product_handle": "dna-rna-shield-collection-tube-w-swab",
		"complements": [
			"dna-rna-shield",
			"bunny-wipe-fecal-sample-collector",
			"ez-dna-methylation-gold-kit",
		]
	},
	"dna-rna-shield-collection-tube-w-swab": {
		"cat_number": "R1109",
		"product_handle": "dna-rna-shield-collection-tube-w-swab",
		"complements": [
			"dna-rna-shield",
			"zymobiomics-dna-miniprep-kit",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"dna-rna-shield-blood-collection-tube": {
		"cat_number": "R1150",
		"product_handle": "dna-rna-shield-blood-collection-tube",
		"complements": [
			"dna-rna-shield",
			"mix-and-go-e-coli-transformation-kit",
		]
	},
	"quick-dna-rna-blood-tube-kit": {
		"cat_number": "R1151",
		"product_handle": "quick-dna-rna-blood-tube-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
			"quick-dna-miniprep-plus-kit",
		]
	},
	"dna-rna-shield": {
		"cat_number": "R1200-125",
		"product_handle": "dna-rna-shield",
		"complements": [
			"dna-clean-concentrator-5",
		]
	},
	"dna-rna-shield": {
		"cat_number": "R1200-25",
		"product_handle": "dna-rna-shield",
		"complements": [
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"quick-rna-whole-blood": {
		"cat_number": "R1201",
		"product_handle": "quick-rna-whole-blood",
		"complements": [
			"quick-dna-miniprep-plus-kit",
			"dna-rna-shield",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"dna-rna-shield-saliva-collection-kit": {
		"cat_number": "R1210",
		"product_handle": "dna-rna-shield-saliva-collection-kit",
		"complements": [
			"dna-rna-shield",
			"bunny-wipe-fecal-sample-collector",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"zymobiomics-rna-miniprep-kit": {
		"cat_number": "R2001",
		"product_handle": "zymobiomics-rna-miniprep-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zymobiomics-dna-rna-miniprep-kit": {
		"cat_number": "R2002",
		"product_handle": "zymobiomics-dna-rna-miniprep-kit",
		"complements": [
			"zymobiomics-dna-miniprep-kit",
			"dna-rna-shield",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"quick-rna-fungal-bacterial-microprep-kit": {
		"cat_number": "R2010",
		"product_handle": "quick-rna-fungal-bacterial-microprep-kit",
		"complements": [
			"dnase-i-set",
			"ez-dna-methylation-gold-kit",
			"rna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-fungal-bacterial-miniprep-kit": {
		"cat_number": "R2014",
		"product_handle": "quick-rna-fungal-bacterial-miniprep-kit",
		"complements": [
			"dnase-i-set",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dna-clean-concentrator-5",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-plant-kit": {
		"cat_number": "R2024",
		"product_handle": "quick-rna-plant-kit",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dnase-i-set",
			"quick-dna-plant-seed-miniprep-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-tissue-insect-kit": {
		"cat_number": "R2030",
		"product_handle": "quick-rna-tissue-insect-kit",
		"complements": [
			"dnase-i-set",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		]
	},
	"quick-rna-fecal-soil-microbe-microprep-kit": {
		"cat_number": "R2040",
		"product_handle": "quick-rna-fecal-soil-microbe-microprep-kit",
		"complements": [
			"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"s-f-rna-lysis-buffer": {
		"cat_number": "R2040-1-50",
		"product_handle": "s-f-rna-lysis-buffer",
		"complements": [
			"rna-wash-buffer",
			"rna-prep-buffer",
			"rna-binding-buffer",
		]
	},
	"zymo-environ-water-rna-kit": {
		"cat_number": "R2042",
		"product_handle": "zymo-environ-water-rna-kit",
		"complements": [
			"dna-rna-shield",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"quick-dna-fungal-bacterial-miniprep-kit",
		]
	},
	"water-concentrating-buffer": {
		"cat_number": "R2042-1-140",
		"product_handle": "water-concentrating-buffer",
		"complements": [
			"zymo-environ-water-rna-kit",
			"dna-clean-concentrator-5",
			"frozen-ez-yeast-transformation-ii-kit",
		]
	},
	"water-concentrating-buffer": {
		"cat_number": "R2042-1-8",
		"product_handle": "water-concentrating-buffer",
		"complements": [
			"dna-rna-shield",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"direct-zol-rna-miniprep-and-lysis-tubes": {
		"cat_number": "R2050",
		"product_handle": "direct-zol-rna-miniprep-and-lysis-tubes",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"ez-dna-methylation-gold-kit",
		]
	},
	"direct-zol-rna-prewash-concentrate": {
		"cat_number": "R2050-2-160",
		"product_handle": "direct-zol-rna-prewash-concentrate",
		"complements": [
			"rna-wash-buffer",
			"dna-clean-concentrator-5",
			"dnase-i-set",
		]
	},
	"direct-zol-rna-prewash-concentrate": {
		"cat_number": "R2050-2-40",
		"product_handle": "direct-zol-rna-prewash-concentrate",
		"complements": [
			"rna-wash-buffer",
			"dnase-i-set",
		]
	},
	"direct-zol-rna-miniprep-and-lysis-tubes": {
		"cat_number": "R2051",
		"product_handle": "direct-zol-rna-miniprep-and-lysis-tubes",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
		]
	},
	"direct-zol-rna-miniprep-kits": {
		"cat_number": "R2052",
		"product_handle": "direct-zol-rna-miniprep-kits",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-miniprep-kits": {
		"cat_number": "R2053",
		"product_handle": "direct-zol-rna-miniprep-kits",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-96-rna-kits": {
		"cat_number": "R2054",
		"product_handle": "direct-zol-96-rna-kits",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-96-rna-kits": {
		"cat_number": "R2055",
		"product_handle": "direct-zol-96-rna-kits",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"rna-clean-concentrator-5",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-96-rna-kits": {
		"cat_number": "R2056",
		"product_handle": "direct-zol-96-rna-kits",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-96-rna-kits": {
		"cat_number": "R2057",
		"product_handle": "direct-zol-96-rna-kits",
		"complements": [
			"dna-clean-concentrator-5",
			"dna-rna-shield",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-microprep-kits": {
		"cat_number": "R2060",
		"product_handle": "direct-zol-rna-microprep-kits",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-microprep-kits": {
		"cat_number": "R2061",
		"product_handle": "direct-zol-rna-microprep-kits",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-microprep-kits": {
		"cat_number": "R2062",
		"product_handle": "direct-zol-rna-microprep-kits",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-microprep-kits": {
		"cat_number": "R2063",
		"product_handle": "direct-zol-rna-microprep-kits",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-miniprep-plus-kits": {
		"cat_number": "R2070",
		"product_handle": "direct-zol-rna-miniprep-plus-kits",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-miniprep-plus-kits": {
		"cat_number": "R2070T",
		"product_handle": "direct-zol-rna-miniprep-plus-kits",
		"complements": [
			"direct-zol-rna-microprep-kits",
			"mix-and-go-e-coli-transformation-kit",
			"direct-zol-rna-miniprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-miniprep-plus-kits": {
		"cat_number": "R2071",
		"product_handle": "direct-zol-rna-miniprep-plus-kits",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-miniprep-plus-kits": {
		"cat_number": "R2072",
		"product_handle": "direct-zol-rna-miniprep-plus-kits",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-rna-miniprep-plus-kits": {
		"cat_number": "R2073",
		"product_handle": "direct-zol-rna-miniprep-plus-kits",
		"complements": [
			"dna-rna-shield",
			"dna-clean-concentrator-5",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"direct-zol-dna-rna-miniprep": {
		"cat_number": "R2080",
		"product_handle": "direct-zol-dna-rna-miniprep",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"direct-zol-dna-wash": {
		"cat_number": "R2080-1-24",
		"product_handle": "direct-zol-dna-wash",
		"complements": [
			"direct-zol-dna-elution-buffer",
			"rna-prep-buffer",
		]
	},
	"direct-zol-dna-wash": {
		"cat_number": "R2080-2-40",
		"product_handle": "direct-zol-dna-wash",
		"complements": [
			"direct-zol-dna-elution-buffer",
			"rna-prep-buffer",
		]
	},
	"direct-zol-dna-elution-buffer": {
		"cat_number": "R2080-3-4",
		"product_handle": "direct-zol-dna-elution-buffer",
		"complements": [
			"direct-zol-dna-wash",
			"rna-prep-buffer",
		]
	},
	"direct-zol-dna-rna-miniprep": {
		"cat_number": "R2080T",
		"product_handle": "direct-zol-dna-rna-miniprep",
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"direct-zol-rna-miniprep-kits",
			"zymoclean-gel-dna-recovery-kit",
		]
	},
	"direct-zol-dna-rna-miniprep": {
		"cat_number": "R2081",
		"product_handle": "direct-zol-dna-rna-miniprep",
		"complements": [
			"dna-rna-shield",
			"direct-zol-rna-miniprep-kits",
			"direct-zol-rna-miniprep-and-lysis-tubes",
		]
	},
	"direct-zol-96-magbead-rna": {
		"cat_number": "R2100",
		"product_handle": "direct-zol-96-magbead-rna",
		"complements": [
			"dna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"chip-dna-clean-concentrator",
		]
	},
	"direct-zol-96-magbead-rna": {
		"cat_number": "R2101",
		"product_handle": "direct-zol-96-magbead-rna",
		"complements": [
			"rna-clean-concentrator-5",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"direct-zol-rna-microprep-kits",
		]
	},
	"direct-zol-96-magbead-rna": {
		"cat_number": "R2102",
		"product_handle": "direct-zol-96-magbead-rna",
		"complements": [
			"direct-zol-rna-miniprep-kits",
			"zymo-spin-ic-columns",
		]
	},
	"direct-zol-96-magbead-rna": {
		"cat_number": "R2103",
		"product_handle": "direct-zol-96-magbead-rna",
		"complements": [
			"quick-dna-fungal-bacterial-miniprep-kit",
			"direct-zol-rna-microprep-kits",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-dna-rna-magbead": {
		"cat_number": "R2130",
		"product_handle": "quick-dna-rna-magbead",
		"complements": [
			"dna-rna-shield",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"magbead-dna-rna-wash-1": {
		"cat_number": "R2130-1-120",
		"product_handle": "magbead-dna-rna-wash-1",
		"complements": [
			"magbead-dna-rna-wash-2",
			"magbinding-beads",
			"viral-dna-rna-buffer",
		]
	},
	"magbead-dna-rna-wash-1": {
		"cat_number": "R2130-1-30",
		"product_handle": "magbead-dna-rna-wash-1",
		"complements": [
			"magbead-dna-rna-wash-2",
			"dnase-rnase-free-water",
		]
	},
	"magbead-dna-rna-wash-2": {
		"cat_number": "R2130-2-20",
		"product_handle": "magbead-dna-rna-wash-2",
		"complements": [
			"magbead-dna-rna-wash-1",
			"dnase-rnase-free-water",
			"rna-wash-buffer",
		]
	},
	"magbead-dna-rna-wash-2": {
		"cat_number": "R2130-2-80",
		"product_handle": "magbead-dna-rna-wash-2",
		"complements": [
			"magbead-dna-rna-wash-1",
			"magbinding-beads",
			"viral-dna-rna-buffer",
		]
	},
	"quick-dna-rna-magbead": {
		"cat_number": "R2131",
		"product_handle": "quick-dna-rna-magbead",
		"complements": [
			"dna-rna-shield",
			"mix-and-go-e-coli-transformation-kit",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"quick-rna-magbead": {
		"cat_number": "R2132",
		"product_handle": "quick-rna-magbead",
		"complements": [
			"dna-rna-shield",
			"quick-dna-rna-magbead",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-rna-magbead": {
		"cat_number": "R2133",
		"product_handle": "quick-rna-magbead",
		"complements": [
			"proteinase-k-w-storage-buffer-set",
			"dna-rna-shield",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zymobiomics-magbead-dna-rna": {
		"cat_number": "R2135",
		"product_handle": "zymobiomics-magbead-dna-rna",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"dna-rna-shield",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"zymobiomics-magbead-dna-rna": {
		"cat_number": "R2136",
		"product_handle": "zymobiomics-magbead-dna-rna",
		"complements": [
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zymobiomics-microbial-community-standard",
			"onestep-pcr-inhibitor-removal-kit",
		]
	},
	"zymobiomics-magbead-rna": {
		"cat_number": "R2137",
		"product_handle": "zymobiomics-magbead-rna",
		"complements": [
			"zymopure-ii-plasmid-miniprep-kit",
			"yeastar-rna-kit",
			"zymobiomics-96-magbead-kit",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zymobiomics-magbead-rna": {
		"cat_number": "R2138",
		"product_handle": "zymobiomics-magbead-rna",
		"complements": [
			"dna-rna-shield",
			"direct-zol-rna-miniprep-and-lysis-tubes",
			"zr-96-bashingbead-lysis-rack",
			"dnase-i-set",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"quick-dna-rna-viral-magbead": {
		"cat_number": "R2140",
		"product_handle": "quick-dna-rna-viral-magbead",
		"complements": [
			"dna-rna-shield",
			"dnase-i-set",
		]
	},
	"quick-dna-rna-viral-magbead": {
		"cat_number": "R2141",
		"product_handle": "quick-dna-rna-viral-magbead",
		"complements": [
			"dna-rna-shield",
			"quick-rna-viral-kit",
		]
	},
	"quick-dna-rna-pathogen-magbead": {
		"cat_number": "R2145",
		"product_handle": "quick-dna-rna-pathogen-magbead",
		"complements": [
			"dnase-i-set",
			"direct-zol-rna-miniprep-kits-sample",
			"zymopure-ii-plasmid-midiprep-kit",
		]
	},
	"quick-dna-rna-pathogen-magbead": {
		"cat_number": "R2146",
		"product_handle": "quick-dna-rna-pathogen-magbead",
		"complements": [
			"dna-clean-concentrator-25",
			"dna-rna-shield",
		]
	},
	"zymo-seq-ribofree-total-rna-library-kit": {
		"cat_number": "R3000",
		"product_handle": "zymo-seq-ribofree-total-rna-library-kit",
		"complements": [
			"dnase-i-set",
			"dna-rna-shield",
			"zymo-seq-udi-primer-sets",
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zymo-seq-ribofree-universal-cdna-kit": {
		"cat_number": "R3001",
		"product_handle": "zymo-seq-ribofree-universal-cdna-kit",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"zymobiomics-microbial-community-standard",
			"direct-zol-rna-miniprep-kits",
		]
	},
	"zymo-seq-ribofree-total-rna-library-kit": {
		"cat_number": "R3003",
		"product_handle": "zymo-seq-ribofree-total-rna-library-kit",
		"complements": [
			"zymo-seq-udi-primer-sets",
			"pcr-strip-magstand",
			"zymobiomics-dna-rna-miniprep-kit",
			"dnase-i-set"
		],
		"cat_number_custom":[
			"E1011"
		]
	},
	"zymo-seq-wash-buffer": {
		"cat_number": "R3004-1-48",
		"product_handle": "zymo-seq-wash-buffer",
		"complements": [
			"feces-catcher",
			"zymo-seq-ribofree-total-rna-library-kit",
			"quick-cfrna-digestion-buffer",
		]
	},
	"zymo-seq-wash-buffer": {
		"cat_number": "R3004-1-6",
		"product_handle": "zymo-seq-wash-buffer",
		"complements": [
			"dna-elution-buffer",
			"dnase-rnase-free-water",
			"pcr-strip-magstand",
		]
	},
	"quick-sars-cov-2-rrt-pcr-kit": {
		"cat_number": "R3011",
		"product_handle": "quick-sars-cov-2-rrt-pcr-kit",
		"complements": [
			"quick-dna-rna-viral-magbead",
			"quick-sars-cov-2-multiplex-kit",
		]
	},
	"quick-sars-cov-2-rrt-pcr-kit": {
		"cat_number": "R3011-1K",
		"product_handle": "quick-sars-cov-2-rrt-pcr-kit",
		"complements": [
			"quick-dna-rna-viral-magbead",
			"magbinding-beads",
			"dna-rna-shield-collection-tube-w-swab-dx",
		]
	},
	"quick-sars-cov-2-multiplex-kit": {
		"cat_number": "R3013",
		"product_handle": "quick-sars-cov-2-multiplex-kit",
		"complements": [
			"quick-sars-cov-2-rrt-pcr-kit",
			"quick-dna-rna-viral-magbead",
			"zymo-seq-ribofree-total-rna-library-kit",
		]
	},
	"quick-sars-cov-2-multiplex-kit": {
		"cat_number": "R3013-1K",
		"product_handle": "quick-sars-cov-2-multiplex-kit",
		"complements": [
			"human-methylated-non-methylated-dna-set-dna-w-primers",
			"quick-16s-ngs-library-prep-kit",
			"mix-and-go-competent-cells-tg1",
		]
	},
	"rattler-plating-beads": {
		"complements": [
			"dna-clean-concentrator-5",
			"zymopure-ii-plasmid-maxiprep-kit",
			"mix-and-go-e-coli-transformation-kit"
		]
	},
	"ez-vac-vacuum-manifold": {
		"cat_number": "S7000",
		"product_handle": "ez-vac-vacuum-manifold",
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"one-way-luer-lock-clear-stopcock",
			"zymopure-ii-plasmid-midiprep-kit",
		]
	},
	"one-way-luer-lock-clear-stopcock": {
		"cat_number": "S7001",
		"product_handle": "one-way-luer-lock-clear-stopcock",
		"complements": [
			"ez-vac-vacuum-manifold",
			"neoprene-stopper",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"neoprene-stopper": {
		"cat_number": "S7002",
		"product_handle": "neoprene-stopper",
		"complements": [
			"one-way-luer-lock-clear-stopcock",
			"ez-vac-vacuum-manifold",
			"zymopure-ii-plasmid-maxiprep-kit",
		]
	},
	"frozen-ez-yeast-transformation-ii-kit": {
		"complements": [
			"zymoprep-yeast-plasmid-miniprep-ii",
			"ypd-plus",
			"zymolyase"
		]
	},
	"frozen-ez-yeast-solution": {
		"complements": [
			"zymobiomics-dnase-rnase-free-water",
            "m-elution-buffer",
			"frozen-ez-yeast-transformation-ii-kit"
		]
	},
	"mix-and-go-e-coli-transformation-kit": {
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"mix-and-go-competent-cells-dh5-alpha"
		]
	},
	"mix-and-go-2x-stock-wash-buffer": {
		"cat_number": "T3001-2-10",
		"product_handle": "mix-and-go-2x-stock-wash-buffer",
		"complements": [
			"mix-and-go-2x-stock-competent-buffer",
			"mix-and-go-dilution-buffer",
			"zymobroth",
		]
	},
	"mix-and-go-2x-stock-wash-buffer": {
		"cat_number": "T3001-2-30",
		"product_handle": "mix-and-go-2x-stock-wash-buffer",
		"complements": [
			"mix-and-go-dilution-buffer",
			"mix-and-go-2x-stock-competent-buffer",
			"zymobroth",
		]
	},
	"mix-and-go-2x-stock-competent-buffer": {
		"cat_number": "T3001-3-10",
		"product_handle": "mix-and-go-2x-stock-competent-buffer",
		"complements": [
			"mix-and-go-2x-stock-wash-buffer",
			"mix-and-go-dilution-buffer",
			"zymobroth",
		]
	},
	"mix-and-go-2x-stock-competent-buffer": {
		"cat_number": "T3001-3-30",
		"product_handle": "mix-and-go-2x-stock-competent-buffer",
		"complements": [
			"mix-and-go-dilution-buffer",
			"mix-and-go-2x-stock-wash-buffer",
			"zymobroth",
		]
	},
	"mix-and-go-dilution-buffer": {
		"cat_number": "T3001-4-20",
		"product_handle": "mix-and-go-dilution-buffer",
		"complements": [
			"mix-and-go-2x-stock-wash-buffer",
			"mix-and-go-2x-stock-competent-buffer",
			"zymobroth",
		]
	},
	"mix-and-go-dilution-buffer": {
		"cat_number": "T3001-4-60",
		"product_handle": "mix-and-go-dilution-buffer",
		"complements": [
			"mix-and-go-2x-stock-wash-buffer",
			"mix-and-go-2x-stock-competent-buffer",
			"zymobroth",
		]
	},
	"mix-and-go-competent-cells-jm109": {
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"zyppy-plasmid-miniprep-kit",
			"mix-and-go-competent-cells-hb101"
		]
	},
	"mix-and-go-competent-cells-dh5-alpha": {
		"complements": [
			"zymopure-ii-plasmid-miniprep-kit",
			"mix-and-go-e-coli-transformation-kit",
			"ampicillin-sodium-solution"
		]
	},
	"mix-and-go-competent-cells-hb101": {
		"complements": [
			"mix-and-go-competent-cells-dh5-alpha",
			"mix-and-go-competent-cells-jm109",
			"zymopure-ii-plasmid-midiprep-kit"
		]
	},
	"mix-and-go-competent-cells-tg1": {
		"complements": [
			"zymopure-ii-plasmid-maxiprep-kit",
			"mix-and-go-competent-cells-jm109",
			"mix-and-go-competent-cells-hb101"
		]
	},
	"mix-and-go-competent-cells-zymo-10b": {
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"mix-and-go-competent-cells-dh5-alpha",
			"mix-and-go-competent-cells-hb101"
		]
	},
	"mix-and-go-competent-cells-xja-autolysis": {
		"complements": [
			"ez-vac-vacuum-manifold",
			"xja-autolysis-glycerol-stock",
			"mix-and-go-competent-cells-dh5-alpha"
		]
	},
	"mix-and-go-competent-cells-xjade3-autolysis": {
		"complements": [
			"mix-and-go-competent-cells-xjbde3-autolysis",
			"dual-media-set",
			"mix-and-go-competent-cells-dh5-alpha"
		]
	},
	"mix-and-go-competent-cells-xjb-autolysis": {
		"complements": [
			"mix-and-go-competent-cells-dh5-alpha",
			"femto-bacterial-dna-quantification-kit",
			"zymo-spin-iic-xlr-columns"
		]
	},
	"mix-and-go-competent-cells-xjbde3-autolysis": {
		"complements": [
			"mix-and-go-competent-cells-dh5-alpha",
			"his-spin-protein-miniprep",
			"mix-and-go-competent-cells-xjade3-autolysis"
		]
	},
	"xja-autolysis-glycerol-stock": {
		"complements": [
			"mix-and-go-e-coli-transformation-kit",
			"mix-and-go-competent-cells-dh5-alpha",
			"xjade3-autolysis-glycerol-stock"
		]
	},
	"xjade3-autolysis-glycerol-stock": {
		"complements": [
			"xja-autolysis-glycerol-stock",
			"mix-and-go-competent-cells-xjade3-autolysis",
			"mix-and-go-competent-cells-dh5-alpha"
		]
	},
	"xjb-autolysis-glycerol-stock": {
		"complements": [
			"mix-and-go-competent-cells-dh5-alpha",
			"mix-and-go-competent-cells-xjb-autolysis",
			"mix-and-go-e-coli-transformation-kit"
		]
	},
	"xjbde3-autolysis-trade-glycerol-stock": {
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"zymopure-ii-plasmid-midiprep-kit",
			"his-spin-protein-miniprep"
		]
	},
	"x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside": {
		"complements": [
			"iptg-isopropyl-b-d-thiogalactopyranoside",
			"zymolyase",
			"zymobroth"
		]
	},
	"alpha-factor-mating-pheromone": {
		"complements": [
			"zymolyase",
			"a-factor-mating-pheromone",
			"frozen-ez-yeast-transformation-ii-kit"
		]
	},
	"yeast-protein-kit": {
		"complements": [
			"frozen-ez-yeast-transformation-ii-kit",
			"zymoprep-yeast-plasmid-miniprep-ii",
			"zymolyase"
		]
	},
	"y-lysis-buffer": {
		"cat_number": "Y1002-1-100",
		"product_handle": "y-lysis-buffer",
		"complements": [
			"zymolyase",
			"5-fluoroorotic-acid",
		]
	},
	"y-lysis-buffer": {
		"cat_number": "Y1002-1-6",
		"product_handle": "y-lysis-buffer",
		"complements": [
			"zymolyase",
			"ez-nucleosomal-dna-prep-kit",
		]
	},
	"ypd-plus": {
		"complements": [
			"frozen-ez-yeast-transformation-ii-kit",
			"quick-dna-fungal-bacterial-miniprep-kit",
			"zymoprep-yeast-plasmid-miniprep-ii"
		]
	},
	"a-factor-mating-pheromone": {
		"complements": [
			"zymolyase",
			"frozen-ez-yeast-transformation-ii-kit"
		]
	},
	"zymolyase-ultra": {
		"complements": [
			"yeastar-genomic-dna-kit",
			"frozen-ez-yeast-transformation-ii-kit",
			"zymolyase"
		]
	},
	"dual-media-set": {
		"complements": [
			"zymoclean-gel-dna-recovery-kit",
			"zymopure-ii-plasmid-midiprep-kit",
			"iptg-isopropyl-b-d-thiogalactopyranoside"
		]
	}
}

const complementPromo = {
	"bundle_and_save": {
		"promo_date": new Date(2024, 10, 1),
		"message": `<p> Get 30% OFF on this product when you bundle and enjoy a FREE T-Shirt on all orders. 
					<a target="_blank" rel="noreferrer noopener" href="/pages/bundle-and-save" 
					class="text-underline">Learn More</a> </p>`
	}
}

const complementPromoProducts = {
	"mix-and-go-competent-cells-dh5-alpha": {
		"promo_name": "bundle_and_save",
	},
	"mix-and-go-competent-cells-zymo-10b": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-jm109": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-hb101": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-tg1": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-e-coli-transformation-kit": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-xja-autolysis": {
		"promo_name": "bundle_and_save"
	},
	"xja-autolysis-glycerol-stock": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-xjade3-autolysis": {
		"promo_name": "bundle_and_save"
	},
	"xjade3-autolysis-glycerol-stock": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-xjb-autolysis": {
		"promo_name": "bundle_and_save"
	},
	"xjb-autolysis-glycerol-stock": {
		"promo_name": "bundle_and_save"
	},
	"mix-and-go-competent-cells-xjbde3-autolysis": {
		"promo_name": "bundle_and_save"
	},
	"xjbde3-autolysis-trade-glycerol-stock": {
		"promo_name": "bundle_and_save"
	},
	"yeast-protein-kit": {
		"promo_name": "bundle_and_save"
	},
	"his-spin-protein-miniprep": {
		"promo_name": "bundle_and_save"
	},
	"zymolyase": {
		"promo_name": "bundle_and_save"
	},
	"dnase-i-set": {
		"promo_name": "bundle_and_save"
	},
	"zymotaq-dna-polymerase": {
		"promo_name": "bundle_and_save"
	},
	"zymotaq-premix": {
		"promo_name": "bundle_and_save"
	},
	"zymotaq-qpcr-premix": {
		"promo_name": "bundle_and_save"
	},
	"dna-degradase-plus": {
		"promo_name": "bundle_and_save"
	},
	"dsdna-shearase-plus": {
		"promo_name": "bundle_and_save"
	},
	"dsdna-shearase-plus-includes-matching-dcc-5-kit": {
		"promo_name": "bundle_and_save"
	},
	"rnase-a": {
		"promo_name": "bundle_and_save"
	},
	"cpg-methylase-m-sssl": {
		"promo_name": "bundle_and_save"
	},
	"atlantis-ds-dnase": {
		"promo_name": "bundle_and_save"
	},
	"proteinase-k-w-storage-buffer-set": {
		"promo_name": "bundle_and_save"
	},
	"5-hmc-glucosyltransferase": {
		"promo_name": "bundle_and_save"
	},
	"micrococcal-nuclease": {
		"promo_name": "bundle_and_save"
	},
	"dna-degradase": {
		"promo_name": "bundle_and_save"
	},
	"frozen-ez-yeast-transformation-ii-kit": {
		"promo_name": "bundle_and_save"
	},
	"zymolyase-ultra": {
		"promo_name": "bundle_and_save"
	},
	"purerec-duplex-specific-nuclease-dsn": {
		"promo_name": "bundle_and_save"
	},
	"purerec-rnase-a-recombinant": {
		"promo_name": "bundle_and_save"
	}
}

function hasComplementPromo(productHandle) {
	if(complementPromoProducts[productHandle]){
		let promoName = complementPromoProducts[productHandle].promo_name;
		if( complementPromo[promoName] ){
			let currentDate = new Date();
			if(currentDate < complementPromo[promoName].promo_date){
				return true;
			}
		}
	}
	return false;
}